/* eslint-disable camelcase */
/* eslint-disable no-redeclare */
/* eslint-disable no-unused-vars */
/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

import React from 'react';
import _, { toArray } from 'lodash';
import moment from 'moment';
import { v4 as uuidv4 } from 'uuid';
import {
  getCurrentInvoiceDrugs,
  getURAData,
  getPqasDrugInfoForDrugs,
  getRosiDrugInfoForDrugs,
  getPostInitByMIR,
  getInvoiceHeader,
  getPqasGridAp2,
  getPqasDrugsFullyPartially,
  getAdjDisputeCodes,
  getPQASDrugsPaidTrnsctionAmt,
  getUraFromDqd,
  getSumOrgPaidAmt,
  getPriorCurrUnits,
  getPQASSummayGridList,
  getRecalValuesForPqas,
  getIdcCurrUra,
  dispatchGetPqasGridAp2,
  addOrDuplicateNDCPQASObjData,
  getPreInitialiseData,
} from '../../store/Actions'; // PQAS Store
import { setUpdateDetails, getCmsDrugInfo } from '../../../store/Actions';
import { ALLOCATE_PAYMENT_DETAIL_SCREEN_URL } from '../../../../../../SharedModules/CommonConstants/commonConstants';
import {
  decrementIncrementQtr,
  handleQuarterFormate,
  getQtrValWithoutQ,
  compareTwoArrayOrObjects,
  cloneArr,
  removeDollarForNumberFiled,
  removeCommaForNumberFiled,
} from '../../../../../../SharedModules/CommonUtilities/commonUtilities';
// eslint-disable-next-line import/no-cycle
import { SummaryRecall, calculateTotalSum } from './tableHead';

// colorData
export const colorCode = {
  greenCd: '00b300',
  greyCd: '12632256',
  disGreyCd: '78682240',
  yellowCd: '11534335',
  whiteCd: '16777215',
  redCd: 'b31f00',
};

const callStatusColorUpdate = (arr, uraRes) => {
  if (uraRes?.data?.length > 0) {
    const uraData = uraRes?.data;
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < arr.length; i += 1) {
      // eslint-disable-next-line no-plusplus
      for (let j = 0; j < uraData.length; j += 1) {
        if (arr[i].drugdrugSeqNum === uraData[j].drugSeqNum) {
          arr[i].ccInterestowed = uraData[j].interestCalculated
            ? uraData[j].interestCalculated
            : 0;
          /* Persist DQD URA for client PMAC validation (fx_validate_pqas_detail). */
          if (
            uraData[j].unitRebateAmt != null &&
            uraData[j].unitRebateAmt !== ''
          ) {
            arr[i].unitRebateAmt = uraData[j].unitRebateAmt;
          }
          // arr[i].currUnitRebateAmt = uraData[j].unitRebateAmt;
          if (
            uraData[j].statusCd === 'WO' ||
            uraData[j].statusCd === 'DB' ||
            uraData[j].statusCd === 'FG' ||
            uraData[j].statusCd === 'DBK'
          ) {
            arr[i].ccOverridColorDis = colorCode.greenCd;
            arr[i].ccOverrideColor = colorCode.whiteCd;
          }
        }
      }
    }
    return arr;
  }
  return arr;
};
const fetchPQASGridCurrUnits = async (payload) => {
  // eslint-disable-next-line no-return-await
  return await getPriorCurrUnits(payload).then((obj) => {
    return obj?.currentUnitsPdAndRdResponseVOs;
  });
};
// Load PQAS Tab Grid Data with all values
export const onLoadPqasGrid = async (
  pqasGridData,
  allocatePaymentHeaderDetail,
  pqasGridLevelActions,
  dispatch
) => {
  let pqasData = !_.isEmpty(pqasGridData) ? [...pqasGridData] : [];
  let invRecSeqNum = 0;
  const previousQtr = pqasGridLevelActions.pgQtrVal;
  // will use these api calls in appropriate places later
  if (previousQtr) {
    const val = {
      isPrevQTR: previousQtr,
      isProgramCode: allocatePaymentHeaderDetail.rebateProgramCd,
      isMFG: allocatePaymentHeaderDetail.mfgId,
    };

    // 1st API 13-17
    await dispatch(
      getPostInitByMIR({
        isPrevQTR: previousQtr, // '1Q1991'
        isProgramCode: allocatePaymentHeaderDetail.rebateProgramCd,
      })
    );

    // 2nd API 18
    const result = await dispatch(getInvoiceHeader(val));
    let dwPQASGridList = [];
    let prevInvNum;
    if (
      result &&
      result?.payload &&
      result?.payload?.postInitByInvoiceHeaderResp.length > 0
    ) {
      prevInvNum =
        result?.payload?.postInitByInvoiceHeaderResp[0]?.idecPrevInvoiceNum;
    }
    const param = {
      idecInvoiceNum: allocatePaymentHeaderDetail.invoiceNum,
      checkLogNum: allocatePaymentHeaderDetail.checkLogNum,
      idecPrevInvoiceNum: prevInvNum,
      currQTR: handleQuarterFormate(allocatePaymentHeaderDetail?.qtr),
      prevQtr: val.isPrevQTR,
    };

    // get pre-initialisation data for invReqSeqNum
    const getPreInitData = await dispatch(
      getPreInitialiseData({
        invoiceNumber: allocatePaymentHeaderDetail.invoiceNum,
        checkLogNum: allocatePaymentHeaderDetail?.checkLogNum,
      })
    );

    // 3rd API 21
    const response = await dispatch(getPqasGridAp2(param));
    if (response?.error === 'API Failed') {
      dispatch(
        dispatchGetPqasGridAp2({
          list: [],
          headerData: allocatePaymentHeaderDetail,
          isUpdateData: true,
        })
      );
    }
    dwPQASGridList =
      response?.payload?.length > 0
        ? JSON.parse(JSON.stringify(response?.payload))
        : [];
    let allDrugSeqNum =
      response.payload?.length > 0
        ? response.payload.map((item) => item.drugdrugSeqNum)
        : [];
    if (response?.payload?.length > 0) {
      pqasData = response?.payload;

      const found = pqasData?.map((el) => {
        if (el.invRecSeqNum !== null || el.invRecSeqNum !== 0) {
          return el.invRecSeqNum;
        }
      });
      if (found?.length > 0) [invRecSeqNum] = found;
    } else {
      pqasData = [];
      dwPQASGridList = [];
    }
    // 4th API 22
    const payload1 = {
      prevQtr: previousQtr,
      currQtr: handleQuarterFormate(allocatePaymentHeaderDetail?.qtr),
      invoiceNumber: allocatePaymentHeaderDetail.invoiceNum,
      // invoiceNumber:
      //   result?.payload?.postInitByInvoiceHeaderResp[0]?.idecPrevInvoiceNum,
    };
    const paidRes = await dispatch(getPqasDrugsFullyPartially(payload1));
    const allDrugSeqNum2 =
      paidRes.payload?.length > 0
        ? paidRes.payload.map((item) => item.drugSeqNum)
        : [];
    allDrugSeqNum = [...new Set([...allDrugSeqNum, ...allDrugSeqNum2])];
    const drugSeqSel = [];

    const uraParams = {
      drugSeqNum: allDrugSeqNum,
      qtr: param.prevQtr,
      rebateProgramCd: allocatePaymentHeaderDetail.rebateProgramCd,
    };
    const uraRes = await dispatch(getUraFromDqd(uraParams)); // 6th API 26.4
    let modifiedNdcsData = [];
    if (paidRes?.payload && paidRes?.payload?.length > 0) {
      const paidFullyData = paidRes?.payload;
      let toAddArray = paidFullyData;

      paidFullyData.forEach((el) => {
        drugSeqSel.push(el.drugSeqNum);
      });

      // Add drugs 4.8.4
      const cmsRes = await dispatch(
        getCmsDrugInfo({
          drugSeqNum: drugSeqSel,
          qtr: previousQtr,
          checkDate: allocatePaymentHeaderDetail?.checkDt
            ? moment(allocatePaymentHeaderDetail?.checkDt).format('MM/DD/YYYY')
            : null,
        })
      );

      if (cmsRes?.getCmsDrugInformation) {
        if (cmsRes?.getCmsDrugInformation?.length > 0) {
          const drugArray = cmsRes?.getCmsDrugInformation;
          drugArray.forEach((item) => {
            const foundVal = paidFullyData?.findIndex(
              (loadArr) => loadArr.drugSeqNum === item.drugSeqNum
            );
            if (
              foundVal > 0 &&
              !paidFullyData[foundVal].currUnitRebateAmt > 0
            ) {
              paidFullyData[foundVal].currUnitRebateAmt = item.unitRebateAmt;
              paidFullyData[foundVal].pqidunitRebateAmt = item.unitRebateAmt;
            }
          });
        }
      }

      if (pqasData?.length > 0) {
        const whichExists = pqasData;
        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < paidFullyData.length; i += 1) {
          const flagIndex = whichExists.findIndex(
            (item) => item.drugdrugSeqNum === paidFullyData[i].drugSeqNum
          );

          if (flagIndex < 0) {
            whichExists.push(paidFullyData[i]);
            // dwPQASGridList.push(paidFullyData[i])
          }
        }

        toAddArray = whichExists;
      }
      if (toAddArray?.length > 0) {
        const refinedToAddArr = toAddArray.map((item) => {
          item.invRecSeqNum = item.invRecSeqNum;
          if (item.statusCd) {
            item.pqasDrugStatusCd = item.statusCd;
          }
          // eslint-disable-next-line no-nested-ternary
          item.drugdrugSeqNum = item.drugdrugSeqNum
            ? item.drugdrugSeqNum
            : item.drugSeqNum
            ? item.drugSeqNum
            : 0;
          return item;
        });
        dwPQASGridList = refinedToAddArr;
        const arrAddNow = callStatusColorUpdate(refinedToAddArr, uraRes);
        modifiedNdcsData = handleAddNDCRow(
          arrAddNow,
          [],
          allocatePaymentHeaderDetail,
          dispatch,
          getPreInitData,
          null,
          null,
          false
        );
      }
    } else {
      const arrAddNow = callStatusColorUpdate(pqasData, uraRes);
      modifiedNdcsData = handleAddNDCRow(
        arrAddNow,
        [],
        allocatePaymentHeaderDetail,
        dispatch,
        getPreInitData,
        null,
        null,
        false
      );
    }

    const adjDisputeParams = {
      drugSeqNumber: allDrugSeqNum,
      invoiceNum: allocatePaymentHeaderDetail.invoiceNum,
      invoiceQtr: param.currQTR,
      targetQtr: val.isPrevQTR,
    };

    dispatch(getAdjDisputeCodes(adjDisputeParams)); // 5th API 26.3
    // 31.12 missing PQAS Logic
    dwPQASGridList = modifiedNdcsData;
    let newObj = [];
    if (dwPQASGridList?.length > 0) {
      const payload = {
        drugSeqNum: dwPQASGridList.map((item) => item.drugdrugSeqNum),
        prevQtr: val.isPrevQTR,
        rebateProgramCd: allocatePaymentHeaderDetail.rebateProgramCd,
        currQtr: param.currQTR,
        invRecSeqNum: dwPQASGridList[0]?.invRecSeqNum,
      };
      const pqasDrugsPaidTranscationAmt = await dispatch(
        getPQASDrugsPaidTrnsctionAmt(payload)
      );
      const sumOrgPaidAmt = await dispatch(getSumOrgPaidAmt(payload));
      const priorCurrUnits = await dispatch(getPriorCurrUnits(payload));
      newObj = dwPQASGridList?.map((item) => {
        const ll_pqas_drug_drug_seq_num = item?.drugSeqNum;

        if (
          ll_pqas_drug_drug_seq_num === '' ||
          ll_pqas_drug_drug_seq_num === null ||
          ll_pqas_drug_drug_seq_num?.toString() === '0'
        ) {
          let ll_prev_qtr_invoice_detail_unit_rebate_amt = parseFloat(
            item?.pqidunitRebateAmt || 0
          );
          let ll_prev_qtr_invoice_detail_num_of_units = parseFloat(
            item?.pqidnumOfUnits || 0
          );

          item.currUnitRebateAmt = parseFloat(
            ll_prev_qtr_invoice_detail_unit_rebate_amt
          ).toFixed(6);
          item.currUnits = parseFloat(
            ll_prev_qtr_invoice_detail_num_of_units
          ).toFixed(3);
          item.originalCurrUnits = parseFloat(
            ll_prev_qtr_invoice_detail_num_of_units
          ).toFixed(4);
          // getPQASDrugsPaidTrnsctionAmt({
          //   drugSeqNum: [item.drugdrugSeqNum],
          //   prevQtr: val.isPrevQTR,
          //   rebateProgramCd: allocatePaymentHeaderDetail.rebateProgramCd,
          //   currQtr: param.currQTR,
          //   invRecSeqNum: item.invRecSeqNum,
          // })
          //   .then((res) => {
          // if (res.status === '001') {
          const result1 =
            pqasDrugsPaidTranscationAmt?.pqasdrugsPaidThisTransactionAmtResponseVo.find(
              (o) => o.drugSeqNum === item.drugdrugSeqNum
            );
          let ldc_pqas_prior_paid_amt = result1?.ldc_pqas_prior_paid_amt || 0;
          ldc_pqas_prior_paid_amt = ldc_pqas_prior_paid_amt || 0;
          // getSumOrgPaidAmt({
          //   drugSeqNum: [item.drugdrugSeqNum],
          //   prevQtr: val.isPrevQTR,
          //   rebateProgramCd: allocatePaymentHeaderDetail.rebateProgramCd,
          //   currQtr: param.currQTR,
          //   invRecSeqNum: item.invRecSeqNum,
          // })
          //   .then((responsePQASGrid) => {
          // if (responsePQASGrid.status === '001') {
          const tempObj =
            sumOrgPaidAmt?.allocPayPQASDrugsGridSumOfAmtRespVo.find(
              (o) => o.drugSeqNum === item.drugdrugSeqNum
            );
          const ldc_rosi_prior_paid_amt = parseFloat(tempObj?.paidAmt || 0);
          const ldc_prior_paid_amt =
            parseFloat(ldc_pqas_prior_paid_amt || 0) +
            parseFloat(ldc_rosi_prior_paid_amt || 0);
          // 31.12.12
          let ll_rosipqas_rowcount = 0;
          let lds_rosipqas_prior_units = [];
          let ll_rosipqas_row = 0;
          let ldc_prior_paid_units = 0;
          let ldc_prior_disputed_units = 0;
          ll_prev_qtr_invoice_detail_num_of_units = 0;
          ll_prev_qtr_invoice_detail_unit_rebate_amt = 0;
          // fetchPQASGridCurrUnits({
          //   drugSeqNum: [item.drugdrugSeqNum],
          //   prevQtr: val.isPrevQTR,
          //   rebateProgramCd:
          //     allocatePaymentHeaderDetail.rebateProgramCd,
          //   currQtr: param.currQTR,
          //   invRecSeqNum: item.invRecSeqNum,
          // }).then((obj) => {
          lds_rosipqas_prior_units =
            priorCurrUnits.currentUnitsPdAndRdResponseVOs.filter(
              (o) => o.drugSeqNum === item.drugdrugSeqNum
            );
          ll_rosipqas_rowcount =
            priorCurrUnits.currentUnitsPdAndRdResponseVOs.length; // ? obj.length : 0;
          if (ll_rosipqas_rowcount > 0) {
            for (let i = 0; i < lds_rosipqas_prior_units?.length; i += 1) {
              if (parseFloat(lds_rosipqas_prior_units[i]?.paidUnits) > 0) {
                ll_rosipqas_row += 1;
              }
              if (ll_rosipqas_row > ll_rosipqas_rowcount) {
                i += 1;
              }
              ldc_prior_paid_units =
                lds_rosipqas_prior_units[i]?.paidUnits || 0;
              ldc_prior_disputed_units =
                lds_rosipqas_prior_units[i]?.priorDisputedUnits;
            }
          } else if (
            ll_rosipqas_rowcount === 0 ||
            ll_rosipqas_row > ll_rosipqas_rowcount
          ) {
            ldc_prior_paid_units = 0;
            ldc_prior_disputed_units = 0;
          }
          item.priorPaidAmt = parseFloat(ldc_prior_paid_amt || 0).toFixed(2);
          item.priorPaidUnits = parseFloat(ldc_prior_paid_units || 0).toFixed(
            3
          );
          item.priorDisputedUnits = parseFloat(
            ldc_prior_disputed_units || 0
          ).toFixed(3);

          ll_prev_qtr_invoice_detail_num_of_units = parseFloat(
            item.pqidnumOfUnits || 0
          );

          ll_prev_qtr_invoice_detail_unit_rebate_amt = parseFloat(
            item.pqidunitRebateAmt || 0
          );

          item.revisedInvoiceAmt = parseFloat(
            ll_prev_qtr_invoice_detail_num_of_units *
              ll_prev_qtr_invoice_detail_unit_rebate_amt
          ).toFixed(2);
          //   return obj;
          // });
          // } else {
          //   dispatch(
          //     setOnLoadPQASGridError({
          //       alert: true,
          //       msg: 'Error selecting sum of paid amt.',
          //     })
          //   );
          //   return { ...item };
          //   // "Error selecting sum of paid amt.
          // }

          //   return responsePQASGrid;
          // })
          // .catch((err) => {
          //   dispatch(
          //     setOnLoadPQASGridError({
          //       alert: true,
          //       msg: 'Error selecting sum of paid amt.',
          //     })
          //   );
          //   return { ...item };
          //   // "Error selecting sum of paid amt.
          // });
          // } else {
          //   dispatch(
          //     setOnLoadPQASGridError({
          //       alert: true,
          //       msg: 'Error selecting sum of paid this transaction amt.',
          //     })
          //   );

          //   // "Error selecting sum of paid this transaction amt."
          //   return { ...item };
          // }
          // return res;
          // })
          // .catch((res) => {
          //   dispatch(
          //     setOnLoadPQASGridError({
          //       alert: true,
          //       msg: 'Error selecting sum of paid this transaction amt.',
          //     })
          //   );
          //   // 'Error selecting sum of paid this transaction amt.';
          //   return { ...item };
          // });
        } else if (
          item.priorPaidAmt === null ||
          item.priorPaidAmt === 0 ||
          parseFloat(item.priorPaidAmt) === 0
        ) {
          item.priorPaidAmt = parseFloat(item.pqaspriorPaidAmt || 0).toFixed(2);
          // if (parseFloat(item.priorPaidAmt) === 0) {
          //   const ldbl_OrigURA =
          //     item.cidunitRebateAmt === null
          //       ? parseFloat(item.currUnitRebateAmt)
          //       : parseFloat(item.cidunitRebateAmt);
          //   item.priorPaidAmt = parseFloat(
          //     ldbl_OrigURA * parseFloat(item.priorPaidUnits || 0)
          //   ).toFixed(2);
          // }
        }
        return item;
      });
    } // 7th API 30.11.5
    const tempObj1 = newObj?.map((item) => {
      const URADQDList =
        uraRes?.data?.length > 0
          ? [
              ...uraRes?.data?.filter((x) => {
                return x.drugSeqNum === item.ciddrugSeqNum;
              }),
            ][0]
          : { interestCalculated: 0, statusCd: '' };
      item.id = uuidv4();
      item.interestCalc = parseFloat(
        URADQDList?.interestCalculated || 0
      ).toFixed(2);
      item.statusCd = URADQDList?.statusCd;
      return item;
    });
    if (tempObj1 && allocatePaymentHeaderDetail) {
      //setTimeout(() => {
      dispatch(
        dispatchGetPqasGridAp2({
          list: tempObj1,
          headerData: allocatePaymentHeaderDetail,
          isUpdateData: true,
          onloadData: tempObj1,
        })
      );
      //}, 100);
    }
    const cfSumOwedAmt = calculateTotalSum(
      'revisedInvoiceAmt',
      tempObj1,
      true,
      allocatePaymentHeaderDetail
    )
      ?.toString()
      ?.replace(',', '')
      .trim();
    const totalPrincipalPaid = calculateTotalSum(
      'paidThisTransactionAmt',
      tempObj1
    )
      ?.toString()
      ?.replace(',', '')
      .trim();

    const principalPaidThisCheck = calculateTotalSum(
      'paidThisTransactionAmt',
      newObj.filter((x) => {
        return (
          x.invRecSeqNum ===
            allocatePaymentHeaderDetail?.reconciliationNumber ||
          x.invRecSeqNum === 0
        );
      })
    )
      ?.toString()
      ?.replace(',', '')
      .trim();
    // call summry grid api here
    dispatch(
      getPQASSummayGridList(
        {
          idecInvoiceNum: allocatePaymentHeaderDetail.invoiceNum,
          checkLogNum: allocatePaymentHeaderDetail?.checkLogNum,
          // idecInvoiceNum:
          //   result?.payload?.postInitByInvoiceHeaderResp[0]?.idecPrevInvoiceNum,
          isPrevQTR: handleQuarterFormate(getQtrValWithoutQ(val.isPrevQTR)),
          ilRPSN: allocatePaymentHeaderDetail?.reconciliationNumber
            ? allocatePaymentHeaderDetail.reconciliationNumber
            : 0,
          isProgramCode: allocatePaymentHeaderDetail.rebateProgramCd,
          isEarliestQtr: handleQuarterFormate(
            allocatePaymentHeaderDetail.defEarliestQtrForDrugDtls
          ),
        },
        cfSumOwedAmt,
        totalPrincipalPaid,
        principalPaidThisCheck
      )
    );
    // call getRecalValuesForPqas API here
    const recalcParams = {
      invoiceNum: allocatePaymentHeaderDetail.invoiceNum,
      currentQtr: handleQuarterFormate(allocatePaymentHeaderDetail?.qtr),
      previousQtr: pqasGridLevelActions.pgQtrVal,
      rpsn:
        allocatePaymentHeaderDetail.recancilationNumber === null
          ? 0
          : allocatePaymentHeaderDetail.recancilationNumber,
    };
    dispatch(getRecalValuesForPqas(recalcParams));
  }
};

// set data with ag-gird table
export const handleSetDataWithTable = (
  data,
  allocatePaymentHeaderDetail,
  updateDetailsAllData,
  activeInvNum,
  activeCheckLogNum,
  dispatch,
  gridParams,
  setRowData
) => {
  // const newData = data;
  dispatch(
    dispatchGetPqasGridAp2({
      list: [],
      headerData: allocatePaymentHeaderDetail,
      isUpdateData: false,
    })
  );
  if (setRowData) {
    setRowData([...data?.sort((a, b) => (a.ndc > b.ndc ? 1 : -1))]);
  }
  dispatch(
    dispatchGetPqasGridAp2({
      list: data?.sort((a, b) => (a.ndc > b.ndc ? 1 : -1)),
      headerData: allocatePaymentHeaderDetail,
      isUpdateData: true,
    })
  );
  // setTimeout(() => {
  if (gridParams) {
    _.debounce(() => {
      // console.log('PQAS-631');
      gridParams.api.refreshCells({ force: true });
    });
  }
  // }, 2000);

  if (updateDetailsAllData) {
    const tempObjFlag = { ...updateDetailsAllData };
    tempObjFlag[`${activeInvNum}-${activeCheckLogNum}`] = {
      ...tempObjFlag[`${activeInvNum}-${activeCheckLogNum}`],
      flag: false,
    };
    dispatch(setUpdateDetails(tempObjFlag));
  }

  return data?.sort((a, b) => (a.ndc > b.ndc ? 1 : -1));

  // if (gridParams?.api) {
  //   gridParams.api.refreshCells({ force: true });
  // }
};
export const addDuplicateNdc = (
  ndcArray,
  pqasGridData,
  allocatePaymentHeaderDetail,
  getPreInitData,
  AddFlag,
  addIntNewNDC
) => {
  const arrayOfNewRows = pqasGridData?.length > 0 ? [...pqasGridData] : [];
  if (!_.isEmpty(ndcArray)) {
    ndcArray.forEach((item) => {
      const getPriorObj = arrayOfNewRows.find(
        (pqasItem) => item.drugSeqNum === pqasItem.drugSeqNum
      );
      item.id = uuidv4();
      item.addEditRow = AddFlag;
      item.addedAsNew = AddFlag;
      item.ndc = removeWhiteSpaceForNDC(item.ndc);
      item.ccAc1 = '';
      item.ccAc2 = '';
      item.ccAc3 = '';
      item.ccDc1 = '';
      item.ccDc2 = '';
      item.ccDc3 = '';
      item.isModifiedCurrUnitsDisputedColumn = false;
      item.corrLinkId =
        !item.corrLinkId && item.corrLinkId?.toString() === '0'
          ? '0'
          : item.corrLinkId
          ? item.corrLinkId
          : 'new';
      item.ccRowSource = item.ccRowSource ? item.ccRowSource : 'ADDORIG';
      item.ccPaidInFullInd = 0;
      item.disabledForPaidInFullInd = false;
      // eslint-disable-next-line no-nested-ternary
      // item.invRecSeqNum = item.invRecSeqNum
      //   ? item.invRecSeqNum
      //   : getPreInitData?.invRecSeqNum
      //   ? getPreInitData?.invRecSeqNum
      //   : 0;
      item.invRecSeqNum = getPreInitData?.invRecSeqNum
        ? getPreInitData?.invRecSeqNum
        : 0;
      // eslint-disable-next-line no-nested-ternary
      item.drugdrugSeqNum = item.drugdrugSeqNum
        ? item.drugdrugSeqNum
        : item.drugSeqNum
        ? item.drugSeqNum
        : 0;
      item.interestSettledInd = addIntNewNDC ? 0 : item.interestSettledInd;
      item.ccCommentsExist = item.ccCommentsExist ? item.ccCommentsExist : 0;
      item.interestPaid = item.interestPaid || parseFloat(0).toFixed(2);
      // item.currUnits = parseFloat(0).toFixed(3);
      // Code fix for 470172
      item.currUnits = parseFloat(item.currUnits).toFixed(3);
      item.parseFloat =
        (parseFloat(item?.ccInterestowed) *
          (item.currUnitsPaid !== null || item.currUnitsPaid === 0
            ? item.currUnits
            : item.currUnitsPaid)) /
        item.currUnits;
      item.interestCalc = Number.isNaN(item.interestCalc || 0)
        ? parseFloat(0).toFixed(2)
        : parseFloat(item.interestCalc).toFixed(2);
      item.ccInterestAllocated = parseFloat(0).toFixed(2);
      item.ccInterestAllocatedCopy = parseFloat(
        item.ccInterestAllocatedCopy
      ).toFixed(2);
      item.cinterestCalculated = 0;
      item.cidunitRebateAmt = item.cidunitRebateAmt
        ? parseFloat(item.cidunitRebateAmt).toFixed(6)
        : parseFloat(0).toFixed(6);
      item.currUnitRebateAmt = item.currUnitRebateAmt
        ? parseFloat(item.currUnitRebateAmt).toFixed(6)
        : parseFloat(0).toFixed(6);
      item.xorigCurrUnitsPaid = item.xorigCurrUnitsPaid
        ? parseFloat(item.xorigCurrUnitsPaid).toFixed(4)
        : parseFloat(0).toFixed(4);
      item.priorPaidUnits = getPriorObj?.currUnitsPaid
        ? parseFloat(getPriorObj?.currUnitsPaid).toFixed(3)
        : parseFloat(0).toFixed(3);

      item.paidThisTransactionAmt = parseFloat(0).toFixed(2);
      item.orgPaidThisTransactionAmt = parseFloat(0).toFixed(2);
      // eslint-disable-next-line no-nested-ternary
      item.xorigAmtPtt = item.xorigAmtPtt
        ? parseFloat(item.xorigAmtPtt).toFixed(2)
        : item.paidThisTransactionAmt
        ? parseFloat(item.paidThisTransactionAmt || 0).toFixed(2)
        : parseFloat(0).toFixed(2);
      item.revisedInvoiceAmt = item.revisedInvoiceAmt
        ? parseFloat(item.revisedInvoiceAmt).toFixed(2)
        : parseFloat(0).toFixed(2);
      item.priorPaidAmt = getPriorObj?.currAmtPaid
        ? parseFloat(getPriorObj?.currAmtPaid).toFixed(2)
        : parseFloat(0).toFixed(2);
      item.currAmtPaid = parseFloat(0).toFixed(2);
      item.currUnitsPaid = parseFloat(0).toFixed(3);
      item.priorDisputedUnits = getPriorObj?.currUnitsDisputed
        ? parseFloat(getPriorObj?.currUnitsDisputed).toFixed(3)
        : parseFloat(0).toFixed(3);
      item.currUnitsDisputed = parseFloat(0).toFixed(3);
      // eslint-disable-next-line no-nested-ternary
      item.xorigUnits = item.xorigUnits
        ? parseFloat(item.xorigUnits)
        : item.currAmtPaid
        ? parseFloat(item.currAmtPaid)
        : parseFloat(0);
      // eslint-disable-next-line no-nested-ternary
      item.xorigUra = item.xorigUra
        ? parseFloat(item.xorigUra)
        : item.currUnitRebateAmt
        ? parseFloat(item.currUnitRebateAmt)
        : parseFloat(0);
      item.isModifiedCurrUnitsDisputedColumn = false;
      item.numOfPrescriptions = item.numOfPrescriptions
        ? item.numOfPrescriptions
        : 0;
      item.numOfUnits = item.numOfUnits ? item.numOfUnits : null;
      item.numOfUnitsOutstanding = item.numOfUnitsOutstanding
        ? item.numOfUnitsOutstanding
        : 0;

      item.paidUnits = item.paidUnits ? item.paidUnits : 0;
      item.pqasDrugCurrUnitsDisputed = item.currUnitsDisputed
        ? parseFloat(item.currUnitsDisputed || 0)
        : 0;
      item.pqiddrugSeqNum = item.drugdrugSeqNum;
      item.pqidinvoiceNum = allocatePaymentHeaderDetail.invoiceNum;
      // item.pqidnumOfUnits = item.currUnitsPaid ? item.currUnitsPaid : 0;
      item.pqidpriorPaidAmt = item.priorPaidAmt ? item.priorPaidAmt : 0;
      item.pqidunitRebateAmt = item.currUnitRebateAmt
        ? item.currUnitRebateAmt
        : 0;
      item.totReimbursedAmt = item.totReimbursedAmt ? item.totReimbursedAmt : 0;
      item.totReimbursedUnits = item.totReimbursedUnits
        ? parseFloat(item.totReimbursedUnits).toFixed(3)
        : parseFloat(0).toFixed(3);
      item.updateDqdInd = 0;
      item.xorigCurrUnitsDisputed = item.currUnitsDisputed
        ? parseFloat(item.currUnitsDisputed || 0)
        : 0;

      // if (_.includes(['WO', 'DB', 'FG', 'DBK'], item.pqasDrugStatusCd)) {
      //   item.ccOverridColorDis = colorCode.greenCd;
      //   item.ccOverrideColor = colorCode.whiteCd;
      // }
      // for color and enable/diable
      let newItem;
      if (item.statusCd) {
        newItem = rowColorAndEnbleDiableLogic(
          item,
          allocatePaymentHeaderDetail.recancilationNumber
        );
      } else {
        newItem = item;
      }
      item.disabledForAmtPaidThisTran = false;
      item.disabledForCcAc1 = false;
      item.disabledForCcAc2 = false;
      item.disabledForCcAc3 = false;
      item.disabledForCcDc1 = false;
      item.disabledForCcDc2 = false;
      item.disabledForCcDc3 = false;
      item.disabledForCurrAmtPaid = false;
      item.disabledForCurrURA = false;
      item.disabledForCurrUnits = false;
      item.disabledForCurrUnitsDisputed = false;
      item.disabledForCurrUnitsPaid = false;
      item.bgColorForCurrURA = colorCode?.whiteCd;
      item.bgColorForCurrUnits = colorCode?.whiteCd;
      item.bgColorForCurrAmtPaid = colorCode?.whiteCd;
      item.bgColorForAmtPaidThisTran = colorCode?.whiteCd;
      item.bgColorForCurrUnitsPaid = colorCode?.whiteCd;
      item.bgColorForCcAc1 = colorCode?.whiteCd;
      item.bgColorForCcAc2 = colorCode?.whiteCd;
      item.bgColorForCcAc3 = colorCode?.whiteCd;
      item.bgColorForCcDc1 = colorCode?.whiteCd;
      item.bgColorForCcDc2 = colorCode?.whiteCd;
      item.bgColorForCcDc3 = colorCode?.whiteCd;
      newItem = item;
      arrayOfNewRows.push(newItem);
    });
  }
  return arrayOfNewRows;
};
export const handleAddNDCRow = (
  ndcArray,
  pqasGridData,
  allocatePaymentHeaderDetail,
  dispatch,
  getPreInitData,
  updateDetailsAllData,
  activeInvNum,
  activeCheckLogNum,
  AddFlag,
  goForUpdate = true,
  gridParams,
  setRowData,
  addOrDuplicateNDCAll,
  addOrDuplicateNDCSingle
) => {
  const arrayOfNewRows = pqasGridData?.length > 0 ? [...pqasGridData] : [];
  let addNDCgetPriorObj = null;
  // if (ndcArray && ndcArray.length === 1) {
  //   // Get the drugSeqNum from ndcArray
  //   const { drugSeqNum } = ndcArray[0];
  //   // Find the entry in arrayOfNewRows with the highest invRecSeqNum for that drugSeqNum

  //   const filteredObj = arrayOfNewRows.filter(
  //     (item) => item.drugSeqNum === drugSeqNum
  //   );

  //   if (filteredObj.length > 0) {
  //     addNDCgetPriorObj = filteredObj.reduce((max, item) =>
  //       item.invRecSeqNum > max.invRecSeqNum ? item : max
  //     );
  //   }
  // }
  if (!_.isEmpty(ndcArray)) {
    ndcArray.forEach((item) => {
      item.id = uuidv4();
      item.addEditRow = AddFlag;
      item.addedAsNew = AddFlag;
      item.isModifiedCurrUnitsDisputedColumn = false;
      item.corrLinkId =
        !item.corrLinkId && item.corrLinkId?.toString() === '0'
          ? '0'
          : item.corrLinkId
          ? item.corrLinkId
          : 'new';
      item.ccRowSource = item.ccRowSource ? item.ccRowSource : 'ADDORIG';
      item.ccPaidInFullInd = item.ccPaidInFullInd ? item.ccPaidInFullInd : 0;
      // eslint-disable-next-line no-nested-ternary
      item.invRecSeqNum = item.invRecSeqNum
        ? item.invRecSeqNum
        : getPreInitData?.invRecSeqNum
        ? getPreInitData?.invRecSeqNum
        : 0;
      // eslint-disable-next-line no-nested-ternary
      item.drugdrugSeqNum = item.drugdrugSeqNum
        ? item.drugdrugSeqNum
        : item.drugSeqNum
        ? item.drugSeqNum
        : 0;
      item.ccCommentsExist = item.ccCommentsExist ? item.ccCommentsExist : 0;
      item.interestPaid = item.interestPaid || parseFloat(0).toFixed(2);
      // item.currUnits = parseFloat(0).toFixed(3);
      // Code fix for 470172
      item.currUnits = parseFloat(item.currUnits ? item.currUnits : 0).toFixed(
        3
      );
      item.parseFloat =
        (parseFloat(item?.ccInterestowed) *
          (item.currUnitsPaid !== null || item.currUnitsPaid === 0
            ? item.currUnits
            : item.currUnitsPaid)) /
        item.currUnits;
      const parsedInterestCalc = parseFloat(item.interestCalc);
      item.interestCalc = isNaN(parsedInterestCalc)
        ? '0.00'
        : parsedInterestCalc.toFixed(2);
      item.ccInterestAllocated = parseFloat(0).toFixed(2);
      item.cinterestCalculated = 0;
      item.cidunitRebateAmt = item.cidunitRebateAmt
        ? parseFloat(item.cidunitRebateAmt).toFixed(6)
        : parseFloat(0).toFixed(6);
      item.currUnitRebateAmt = item.currUnitRebateAmt
        ? parseFloat(item.currUnitRebateAmt).toFixed(6)
        : parseFloat(0).toFixed(6);
      item.xorigCurrUnitsPaid = item.xorigCurrUnitsPaid
        ? parseFloat(item.xorigCurrUnitsPaid).toFixed(4)
        : parseFloat(0).toFixed(4);
      item.priorPaidUnits =
        addNDCgetPriorObj && addNDCgetPriorObj?.currUnitsPaid
          ? parseFloat(addNDCgetPriorObj?.currUnitsPaid).toFixed(3)
          : item.priorPaidUnits
          ? parseFloat(item.priorPaidUnits).toFixed(3)
          : parseFloat(0).toFixed(3);

      item.paidThisTransactionAmt = item.paidThisTransactionAmt
        ? parseFloat(item.paidThisTransactionAmt).toFixed(2)
        : parseFloat(0).toFixed(2);
      item.orgPaidThisTransactionAmt = addNDCgetPriorObj
        ? parseFloat(0).toFixed(2)
        : item?.orgPaidThisTransactionAmt
        ? parseFloat(item?.orgPaidThisTransactionAmt).toFixed(2)
        : parseFloat(0).toFixed(2);
      // eslint-disable-next-line no-nested-ternary
      item.xorigAmtPtt = item.xorigAmtPtt
        ? parseFloat(item.xorigAmtPtt).toFixed(2)
        : item.paidThisTransactionAmt
        ? parseFloat(item.paidThisTransactionAmt || 0).toFixed(2)
        : parseFloat(0).toFixed(2);
      item.revisedInvoiceAmt = item.revisedInvoiceAmt
        ? parseFloat(item.revisedInvoiceAmt).toFixed(2)
        : parseFloat(0).toFixed(2);
      item.priorPaidAmt =
        addNDCgetPriorObj && addNDCgetPriorObj?.currAmtPaid
          ? parseFloat(addNDCgetPriorObj?.currAmtPaid).toFixed(2)
          : item.priorPaidAmt
          ? parseFloat(item.priorPaidAmt).toFixed(2)
          : parseFloat(0).toFixed(2);
      item.currAmtPaid = item.currAmtPaid
        ? parseFloat(item.currAmtPaid).toFixed(2)
        : parseFloat(0).toFixed(2);
      item.currUnitsPaid = item.currUnitsPaid
        ? parseFloat(item.currUnitsPaid).toFixed(3)
        : parseFloat(0).toFixed(3);
      item.priorDisputedUnits =
        addNDCgetPriorObj && addNDCgetPriorObj?.currUnitsDisputed
          ? parseFloat(addNDCgetPriorObj?.currUnitsDisputed).toFixed(3)
          : item.priorDisputedUnits
          ? parseFloat(item.priorDisputedUnits).toFixed(3)
          : parseFloat(0).toFixed(3);
      item.currUnitsDisputed = item.currUnitsDisputed
        ? parseFloat(item.currUnitsDisputed || 0).toFixed(3)
        : item.currUnitsDisputed;
      // eslint-disable-next-line no-nested-ternary
      item.xorigUnits = item.xorigUnits
        ? parseFloat(item.xorigUnits)
        : item.currAmtPaid
        ? parseFloat(item.currAmtPaid)
        : parseFloat(0);
      // eslint-disable-next-line no-nested-ternary
      item.xorigUra = item.xorigUra
        ? parseFloat(item.xorigUra)
        : item.currUnitRebateAmt
        ? parseFloat(item.currUnitRebateAmt)
        : parseFloat(0);
      item.isModifiedCurrUnitsDisputedColumn = false;
      item.numOfPrescriptions = item.numOfPrescriptions
        ? item.numOfPrescriptions
        : 0;
      item.numOfUnits = item.numOfUnits ? item.numOfUnits : null;
      item.numOfUnitsOutstanding = item.numOfUnitsOutstanding
        ? item.numOfUnitsOutstanding
        : 0;

      item.paidUnits = item.paidUnits ? item.paidUnits : 0;
      item.pqasDrugCurrUnitsDisputed = item.currUnitsDisputed
        ? parseFloat(item.currUnitsDisputed || 0)
        : 0;
      item.pqiddrugSeqNum = item.drugdrugSeqNum;
      item.pqidinvoiceNum = allocatePaymentHeaderDetail.invoiceNum;
      // item.pqidnumOfUnits = item.currUnitsPaid ? item.currUnitsPaid : 0;
      item.pqidpriorPaidAmt = item.priorPaidAmt ? item.priorPaidAmt : 0;
      item.pqidunitRebateAmt = item.pqidunitRebateAmt
        ? item.pqidunitRebateAmt
        : 0;
      item.totReimbursedAmt = item.totReimbursedAmt ? item.totReimbursedAmt : 0;
      item.totReimbursedUnits = item.totReimbursedUnits
        ? parseFloat(item.totReimbursedUnits).toFixed(3)
        : parseFloat(0).toFixed(3);
      item.updateDqdInd = 0;
      item.xorigCurrUnitsDisputed = item.currUnitsDisputed
        ? parseFloat(item.currUnitsDisputed || 0)
        : 0;
      item.ccOverridePrevVals = 0;
      item.disabledForPriorUnitsPaid = true;
      item.disabledForPriorUnitsDisputed = true;
      item.disabledForPriorAmtPaid = true;
      item.bgColorForPriorUnitsPaid = colorCode?.greyCd;
      item.bgColorForPriorUnitsDisputed = colorCode?.greyCd;
      item.bgColorForPriorAmtPaid = colorCode?.greyCd;
      // if (_.includes(['WO', 'DB', 'FG', 'DBK'], item.pqasDrugStatusCd)) {
      //   item.ccOverridColorDis = colorCode.greenCd;
      //   item.ccOverrideColor = colorCode.whiteCd;
      // }
      // for color and enable/diable
      let newItem;
      if (item.statusCd) {
        newItem = rowColorAndEnbleDiableLogic(
          item,
          allocatePaymentHeaderDetail.recancilationNumber
        );
      } else {
        newItem = item;
      }
      arrayOfNewRows.push(newItem);
      if (item.addedAsNew && addOrDuplicateNDCSingle) {
        const newObj =
          typeof addOrDuplicateNDCSingle === 'boolean'
            ? []
            : addOrDuplicateNDCSingle || [];
        newObj.push(item);
        const temp = addOrDuplicateNDCAll ? { ...addOrDuplicateNDCAll } : {};
        temp[`${activeInvNum}-${activeCheckLogNum}`] = newObj;
        dispatch(addOrDuplicateNDCPQASObjData(temp));
      }
    });
  }
  if (goForUpdate) {
    return handleSetDataWithTable(
      arrayOfNewRows,
      allocatePaymentHeaderDetail,
      updateDetailsAllData,
      activeInvNum,
      activeCheckLogNum,
      dispatch,
      gridParams,
      setRowData
    );
  }
  return arrayOfNewRows;
};
export const uf_AddDrugs = async (
  arrayAfterFilter,
  isBuild,
  drugSeqSel,
  allocatePaymentHeaderDetail,
  searchScreenObj,
  dispatch,
  pqasGridData,
  drugsFullyPartially,
  pqasGridLevelActions,
  getPreInitData,
  updateDetailsAllData,
  activeInvNum,
  activeCheckLogNum,
  getPrevInv = {},
  goForUpdate = true,
  gridParams,
  setRowData,
  addOrDuplicateNDCAll,
  addOrDuplicateNDCSingle,
  isIntSet,
  intSetVal
) => {
  const beforeArrayFilter = _.cloneDeep(arrayAfterFilter);
  const functionResponse = addNewNDC(
    arrayAfterFilter,
    isBuild,
    drugSeqSel,
    allocatePaymentHeaderDetail,
    searchScreenObj,
    dispatch,
    pqasGridData,
    drugsFullyPartially,
    pqasGridLevelActions,
    getPrevInv,
    gridParams,
    setRowData
  );

  functionResponse.then(
    (res) => {
      if (
        (_.isEmpty(drugSeqSel) && !goForUpdate && isBuild === 0, _.isEmpty(res))
      ) {
        return res;
      }
      const uniqueArrObj = res.filter(
        (value, index, self) =>
          index === self.findIndex((t) => t.ndc === value.ndc)
      );
      if (isIntSet) {
        uniqueArrObj[0].interestSettledInd = intSetVal;
      }
      const result = handleAddNDCRow(
        uniqueArrObj,
        pqasGridData,
        allocatePaymentHeaderDetail,
        dispatch,
        getPreInitData,
        updateDetailsAllData,
        activeInvNum,
        activeCheckLogNum,
        true,
        goForUpdate,
        gridParams,
        setRowData,
        addOrDuplicateNDCAll,
        addOrDuplicateNDCSingle
      );
    },
    (err) => {
      return false;
    }
  );
};

export const addNewNDC = async (
  ls_NDCs = null,
  ab_build = null,
  lds_PQ = null,
  headerDetail,
  searchScreenObj,
  dispatch,
  pqasGridData,
  drugsFullyPartially = null,
  pqasGridLevelActions,
  getPrevInv = {},
  cmsRes
) => {
  let refinedNDCs = [];

  if (!_.isEmpty(getPrevInv)) {
    const invoiceRes = await dispatch(
      getCurrentInvoiceDrugs({
        drugSeqNumbers: lds_PQ,
        invoiceNum: getPrevInv.idecPrevInvoiceNum,
      })
    );
    if (invoiceRes?.status === '001' && invoiceRes?.currentInvoiceDetailsVOs) {
      if (ab_build === 1) {
        // 4.8.2 and 4.8.3(this will run for both onLoad and Add UI)
        refinedNDCs = callPQASLoop(
          invoiceRes,
          ls_NDCs,
          headerDetail,
          pqasGridData,
          pqasGridLevelActions
        );
      }
    } else if (!invoiceRes?.currentInvoiceDetailsVOs) {
      if (ab_build === 1) {
        refinedNDCs = await callOtherValuesFromApi(
          lds_PQ,
          headerDetail,
          dispatch,
          ls_NDCs,
          cmsRes,
          pqasGridLevelActions
        );
      }
    }
    if (
      invoiceRes?.status === '001' &&
      invoiceRes?.currentInvoiceDetailsVOs?.length > 0
    ) {
      if (ab_build === 1) {
        refinedNDCs = await callOtherValuesFromApi(
          lds_PQ,
          headerDetail,
          dispatch,
          ls_NDCs,
          cmsRes,
          pqasGridLevelActions
        );
      }
    } else {
      if (ab_build === 1) {
        const previousQtr = pqasGridLevelActions.pgQtrVal;
        const cmsResVo = await dispatch(
          getCmsDrugInfo({
            drugSeqNum: lds_PQ,
            qtr: previousQtr,
            checkDate: headerDetail?.checkDt
              ? moment(headerDetail?.checkDt).format('MM/DD/YYYY')
              : null,
          })
        );
        refinedNDCs = await callOtherValuesFromApi(
          lds_PQ,
          headerDetail,
          dispatch,
          ls_NDCs,
          cmsResVo,
          pqasGridLevelActions
        );
      }
    }
  }
  return refinedNDCs;
};

const callPQASLoop = (
  invoiceRes,
  ls_NDCs,
  headerDetail,
  pqasGridData,
  pqasGridLevelActions
) => {
  const dupNDC = [];
  const getConfirmationToAdd = [];
  if (invoiceRes?.currentInvoiceDetailsVOs?.length === 0) {
    const newDrugs = ls_NDCs.map((item, key) => {
      if (item.productCode !== 'ADJS') {
        // this is where user tries to add drug which is not part of original invoice

        // confirmation error message to appear with yes and no
        getConfirmationToAdd.push({
          drugSeqNum: item.drugSeqNum,
          message: `NDC ${item.ndc} was not on original Invoice #${String(
            headerDetail?.invoiceNum
          )}are you sure you want to add it? NDC ${
            item.ndc
          } was not on original Invoice #${String(
            headerDetail?.invoiceNum
          )}, are you sure you want to add it?`,
        });
      } else {
        // 4.8.2.9
        // eslint-disable-next-line no-lonely-if
        if (item.productCode === 'ADJS') {
          item.currUnitRebateAmt = 1;
          item.currUnitRebateAmtOld = 1;
        }
      }

      pqasGridData.forEach((row, index) => {
        if (row.drugdrugSeqNum === item.drugSeqNum) {
          dupNDC.push({
            drugSeqNum: row.drugdrugSeqNum,
            message: `drug_product_code = '${item.productCode}' AND drug_package_size = '${item.packageSize}'`,
            rowNumber: index + 1,
          }); // if drug already exists in the PQAS grid
          item.cc_add_type = 'DUP';
        }
      });

      item.drugdrugSeqNum = item.drugSeqNum;
      // item.currUnitRebateAmt = item.currUnitRebateAmt
      //   ? item.currUnitRebateAmt
      //   : 0;
      item.currUnitRebateAmt =
        item.unitRebateAmt || item.currUnitRebateAmt || 0;
      item.ccCommentsExist = 0;
      item.pqiddrugSeqNum = item.drugSeqNum;
      item.pqidinvoiceNum = headerDetail?.invoiceNum;
      item.rosiPqasQtr = pqasGridLevelActions.pgQtrVal;
      item.prevQtr = pqasGridLevelActions.pgQtrVal;
      item.ccRowSource = 'ADDPD';
      item.priorPaidUnits = 0;
      item.currUnitsPaid = 0;
      item.priorDisputedUnits = 0;
      item.priorPaidAmt = 0;
      item.currUnitsDisputed = parseFloat(0).toFixed(3);
      item.currAmtPaid = 0;
      item.paidThisTransactionAmt = parseFloat(0).toFixed(2);
      item.interestSettledInd = 0;
      item.ccInterestAllocated = 0;
      item.ccPaidInFullInd = 0;
      item.pqasinvoiceNum = headerDetail?.invoiceNum;
      item.cidunitRebateAmt = 0;
      item.revisedInvoiceAmt = 0;
      item.pqidunitRebateAmt = item.currUnitRebateAmt
        ? item.currUnitRebateAmt
        : 0;
      item.addEditRow = true;
      item.currUnits = 0;
      item.bgColorForNDC = '12632256';
      return item;
    });

    return newDrugs;
  }
  if (invoiceRes?.currentInvoiceDetailsVOs?.length > 0) {
    // 4.8.3
    const newDrugs = ls_NDCs.map((item, key) => {
      // eslint-disable-next-line no-unused-expressions
      invoiceRes?.currentInvoiceDetailsVOs.map((data) => {
        if (data.drugSeqNum === item.drugSeqNum) {
          item.drugdrugSeqNum = data.drugSeqNum;
          item.pqiddrugSeqNum = data.drugSeqNum;
          item.ccCommentsExist = 0;
          item.addEditRow = true;
          item.interestSettledInd = 0;
          pqasGridData.forEach((row) => {
            if (row.drugdrugSeqNum === item.drugSeqNum) {
              item.interestCalc = row.interestCalc ? row.interestCalc : 0;
            }
          });
          item.bgColorForNDC = '12632256';
          item.cidunitRebateAmt = data.unitRebateAmt ? data.unitRebateAmt : 0;
          item.currUnitRebateAmt = data.unitRebateAmt ? data.unitRebateAmt : 0;
          item.xorigUra = data.unitRebateAmt ? data.unitRebateAmt : 0;
          item.totReimbursedUnits = data.totReimbursedUnits
            ? data.totReimbursedUnits
            : 0;
          item.currUnits = data.totReimbursedUnits
            ? data.totReimbursedUnits
            : 0;
          item.xorigUnits = data.totReimbursedUnits
            ? data.totReimbursedUnits
            : 0;
          item.totReimbursedAmt = data.totReimbursedAmt
            ? data.totReimbursedAmt
            : 0;
          item.xorigAmtPtt = data.totReimbursedAmt ? data.totReimbursedAmt : 0;
          item.numOfPrescriptions = data.numOfPrescriptions;
          item.revisedInvoiceAmt = parseFloat(
            parseFloat(data.totReimbursedAmt) * parseFloat(data.unitRebateAmt)
          ).toFixed(2);

          item.pqidunitRebateAmt = data.unitRebateAmt ? data.unitRebateAmt : 0;
          item.pqidinvoiceNum = headerDetail?.invoiceNum;

          item.currUnitsDisputed = parseFloat(0).toFixed(3);
          item.addedAsNew = true;
        }
        return data;
      });

      return item;
    });

    return newDrugs;
  }
};
// round off amount
export const roundOffAmt = (amount) => {
  const factor = 100;
  return amount < 0
    ? -Math.round(Math.abs(amount) * factor) / factor
    : Math.round(amount * factor) / factor;
};
// export const roundOffAmt = (calCulatedAmount) => {
//   let roundedAmt = Math.round(calCulatedAmount * 10000) / 10000;
//   let roundedAmtValue = Math.round(roundedAmt * 100) / 100;
//   return roundedAmtValue;
// };
const callOtherValuesFromApi = async (
  lds_PQ,
  headerDetail,
  dispatch,
  ls_NDCs,
  cmsRes,
  pqasGridLevelActions
) => {
  let newDrugs = [];
  const uraRes = await dispatch(
    getURAData({
      drugSeqNum: lds_PQ,
      qtr: handleQuarterFormate(headerDetail?.qtr),
      rebateProgramCd: headerDetail?.rebateProgramCd,
    })
  );
  if (uraRes?.data?.length > 0) {
    newDrugs = ls_NDCs.map((item, index) => {
      // eslint-disable-next-line no-unused-expressions
      uraRes?.data?.map((data) => {
        if (item.drugSeqNum === data.drugSeqNum) {
          item.drugdrugSeqNum = item.drugSeqNum;
          item.cc_interest_allocated = data.interestCalculated;
          item.unitRebateAmt = data.unitRebateAmt;
        }
      });
      return item;
    });
  }
  if (cmsRes?.getCmsDrugInformation?.length > 0) {
    newDrugs = ls_NDCs.map((item, index) => {
      // eslint-disable-next-line no-unused-expressions
      const drugArray = cmsRes?.getCmsDrugInformation;
      drugArray.forEach((elem) => {
        if (elem.drugSeqNum === item.drugSeqNum) {
          item.unitRebateAmt = elem.unitRebateAmt;
        }
      });
      // 4.8.6.7
      return item;
    });
  }
  const pqasInfoRes = await dispatch(
    getPqasDrugInfoForDrugs({
      drugSeqNumbers: lds_PQ,
      currentQtr: handleQuarterFormate(headerDetail?.qtr),
      previousQtr: pqasGridLevelActions.pgQtrVal,
      rebateProgramCd: headerDetail?.rebateProgramCd,
    })
  );
  if (pqasInfoRes.pqasDrugInformationVOs.length > 0) {
    newDrugs = ls_NDCs.map((item) => {
      // find matches for this drugSeqNum
      let matchesDrugSeqNum = pqasInfoRes.pqasDrugInformationVOs.filter(
        (data) => item.drugSeqNum === data.drugSeqNum
      );
      if (matchesDrugSeqNum.length > 0) {
        // sort by invoiceQtr desc
        matchesDrugSeqNum.sort(
          (a, b) => Number(b.invoiceQtr) - Number(a.invoiceQtr)
        );
        // pick latest record
        const lds_FindPQAS = matchesDrugSeqNum[0];
        const ll_curr_unit_rebate_amt = lds_FindPQAS.currUnitRebateAmt;
        const ll_curr_units = lds_FindPQAS.currUnits;
        const ll_curr_units_paid = lds_FindPQAS.currUnitsPaid;
        const ll_curr_units_disputed = lds_FindPQAS.currUnitsDisputed;
        const ll_curr_amt_paid = lds_FindPQAS.currAmtPaid;
        return {
          ...item,
          drugdrugSeqNum: item.drugSeqNum,
          corrLinkId: lds_FindPQAS.corrLinkId,
          currUnits: ll_curr_units,
          currUnitRebateAmt: ll_curr_unit_rebate_amt,
          //cidunitRebateAmt: ll_curr_unit_rebate_amt,
          priorPaidUnits: ll_curr_units_paid,
          priorDisputedUnits: ll_curr_units_disputed,
          revisedInvoiceAmt: roundOffAmt(
            parseFloat(ll_curr_unit_rebate_amt || 0) *
              parseFloat(ll_curr_units || 0)
          ),
          xorigAmtPtt: roundOffAmt(
            parseFloat(ll_curr_unit_rebate_amt || 0) *
              parseFloat(item.totReimbursedUnits || 0)
          ),
          priorPaidAmt: ll_curr_amt_paid,
          curr_invoice_detail_invoice_num: lds_FindPQAS?.invoiceNum,
          cc_row_source: 1,
          invRecSeqNum: 0,
          ccPaidInFullInd: 0,
        };
      }
      // if no matches found, return item as is
      return item;
    });
  } else {
    const rosiInfoRes = await dispatch(
      getRosiDrugInfoForDrugs({
        drugSeqNumbers: lds_PQ,
        previousQtr: pqasGridLevelActions.pgQtrVal,
        rebateProgramCd: headerDetail?.rebateProgramCd,
      })
    );
    if (rosiInfoRes?.rosiDrugInformationVOs?.length > 0) {
      newDrugs = ls_NDCs.map((item, index) => {
        rosiInfoRes.rosiDrugInformationVOs.map((data) => {
          if (item.drugSeqNum === data.drugSeqNum) {
            item.drugdrugSeqNum = item.drugSeqNum;
            item.corrLinkId = data.corrLinkId;
            item.adjustedUnitRebateAmt = data.adjustedUnitRebateAmt;
            item.adjustedUnits = data.adjustedUnits;
            item.paidUnits = data.paidUnits;
            item.disputedUnits = data.disputedUnits;
            item.paidAmt = data.paidAmt;
            item.curr_invoice_detail_invoice_num = data?.invoiceNum;
            item.cc_row_source = 1; // when added from UI through actions
            item.invRecSeqNum = 0;
            item.ccPaidInFullInd = 0;
            item.interestSettledInd = 0;
          }
        });
        return item;
      });
    } else {
      newDrugs = ls_NDCs.map((item, index) => {
        item.bgColorForInterestCalc = colorCode.greyCd;
        item.bgColorForOrgURA = colorCode.greyCd;
        item.bgColorForOrgUnitsInv = colorCode.greyCd;
        item.bgColorForOrgInvAmt = colorCode.greyCd;
        item.bgColorForRevisedInvAmt = colorCode.greyCd;
        // 4.8.6.7
        return item;
      });
    }
  }
  return newDrugs;
};

export const pqasPageChanges = (pqasGridLevelActions, data) => {
  const activeInvNum = window.location.pathname
    ?.split(ALLOCATE_PAYMENT_DETAIL_SCREEN_URL)[1]
    ?.split('-')[1];
  const activeCheckLogNum = window.location.pathname
    ?.split(ALLOCATE_PAYMENT_DETAIL_SCREEN_URL)[1]
    ?.split('-')[0];
  let currData = {};
  if (!_.isEmpty(pqasGridLevelActions)) {
    currData = _.pick(pqasGridLevelActions, [
      `${activeInvNum}-${activeCheckLogNum}`,
    ]);
  }
  if (!_.isEmpty(currData)) {
    currData = {
      ...currData[`${activeInvNum}-${activeCheckLogNum}`],
      ...data,
    };
  } else {
    currData = { ...data };
  }
  if (!_.isEmpty(pqasGridLevelActions)) {
    return {
      ...pqasGridLevelActions,
      [`${activeInvNum}-${activeCheckLogNum}`]: {
        ...currData,
      },
    };
  }
  return {
    [`${activeInvNum}-${activeCheckLogNum}`]: {
      ...currData,
    },
  };
};

// Re-calculation Action

export const ue_Recalc = async (
  params,
  ab_now,
  ab_Init,
  isRow,
  isUpdateData
) => {
  console.time('ue_Recalc');
  // double data type in java
  let ldbl_Int = 0;
  let ldbl_Prin = 0;
  let ldbl_TotPrin = 0;
  let ldbl_Tmp = 0;
  let ldbl_TotInt;
  let ldbl_OthPrin2 = 0;
  let ldbl_IntStld;
  let ldbl_Tmp2 = 0;
  let ldbl_PrevPrin = 0;
  let lb_IntMod;
  let lb_OneMod;
  let ll_return = null;
  let ll_pqas_drug_paid_this_transaction_amt = 0;
  let ll_find;
  let ll_tot_interest_paid;
  let ll_interest_paid;
  let tot_interest_paid;
  let ll_principal_paid;
  let ll_tot_principal_paid;
  let ll_tot_interest_alloc;
  let ll_tot_curr_qtr_amt;
  let ll_getPrin = null;
  let ll_getInt;

  const {
    row,
    pqasData,
    orgData,
    preValues,
    recalcResult,
    summaryGrid,
    rosiSummaryGrid,
    idsDealloc,
    allocatePaymentHeaderDetail,
    pqasAllSummaryGridList,
    dispatch,
    activeInvNum,
    activeCheckLogNum,
    disabledIntPaidAllPQAS,
    headerAllocatePaymentData,
  } = params;
  const pqasGridData = Array.isArray(params.pqasData)
    ? [...params.pqasData]
    : [];
  const updatedRow = { ...row };
  delete updatedRow.addEditRow;
  delete updatedRow.cfSumOwedAmt;
  const il_rpsn =
    allocatePaymentHeaderDetail?.recancilationNumber === null
      ? 0
      : allocatePaymentHeaderDetail?.recancilationNumber;
  const sumGrid = Array.isArray(summaryGrid) ? [...summaryGrid] : [];
  // sumGrid = sumGrid.map((item) => {
  //   return {
  //     ...item,
  //     currentPrincipalAmt: parseFloat(
  //       item.currentPrincipalAmt?.replace(/[^0-9]/g, '')
  //     ),
  //     intPaidThisCheck: parseFloat(
  //       item.intPaidThisCheck?.replace(/[^0-9]/g, '')
  //     ),
  //     // principalPaid: parseFloat(item.principalPaid?.replace(/[^0-9]/g, '')),
  //     principalPaidThisCheck: parseFloat(
  //       item.principalPaidThisCheck?.replace(/[^0-9]/g, '')
  //     ),
  //     totalIntPaid: parseFloat(item.totalIntPaid?.replace(/[^0-9]/g, '')),
  //     totalIntSettled: parseFloat(item.totalIntSettled?.replace(/[^0-9]/g, '')),
  //     totalInterestCalc: parseFloat(
  //       item.totalInterestCalc?.replace(/[^0-9]/g, '')
  //     ),
  //     totalPrincipalPaid: parseFloat(
  //       item.totalPrincipalPaid?.replace(/[^0-9]/g, '')
  //     ),
  //   };
  // })
  let rosiSumGrid = Array.isArray(rosiSummaryGrid) ? [...rosiSummaryGrid] : [];
  rosiSumGrid = rosiSumGrid.map((item) => {
    return {
      ...item,
      principalPaid: (item?.principalPaid || '').replace(/\$/g, '').trim(),
      totalIntPaid: (item?.totalIntPaid || '').replace(/\$/g, '').trim(),
    };
  });
  const hasSummaryRows = sumGrid.length > 0;
  const summaryObj = sumGrid[0] ? { ...sumGrid[0] } : {};
  const updatedPqas = [];
  const updatedSummaryGrid = {};
  const pqasData2 = Array.isArray(pqasData)
    ? pqasData.map((item) => ({ ...item }))
    : [];
  let dw_pqas = Array.isArray(pqasData)
    ? pqasData.map((item) => ({ ...item }))
    : [];
  let orgPqas = Array.isArray(orgData)
    ? orgData.map((item) => ({ ...item }))
    : [];

  dw_pqas = dw_pqas.map((item) => {
    delete item.addEditRow;
    delete item.cfSumOwedAmt;
    return item;
  });
  orgPqas = orgPqas.map((item) => {
    delete item.addEditRow;
    delete item.cfSumOwedAmt;
    return item;
  });
  const isPqasArrModified = checkAddEditRow(pqasData);
  const orgById = new Map(orgPqas.map((item) => [item.id, item]));
  const idsDeallocSet = new Set(
    Array.isArray(idsDealloc)
      ? idsDealloc.map((item) => item?.drugdrugSeqNum)
      : []
  );
  // const isPqasArrModified = await isPqasModified(
  //   _.cloneDeep(pqasData),
  //   _.cloneDeep(orgPqas)
  // );
  const changedUpdatedRow = !isRow
    ? uf_PQASRowChanged(updatedRow, orgById.get(updatedRow.id))
    : false;
  if (!_.isEmpty(pqasData2)) {
    const sortedPqasData = [...pqasData2].sort((a, b) =>
      a.ndc > b.ndc ? 1 : -1
    );
    _.forEach(sortedPqasData, (val, ll_row) => {
      lb_OneMod = false;
      lb_IntMod = false;
      val.ll_dsn = val.drugSeqNum;
      val.ll_inv_rec_seq_num = val.invRecSeqNum;
      // 3.5

      if (val.ll_inv_rec_seq_num === null) {
        val.ll_inv_rec_seq_num = 0;
      }
      const orgObj2 = orgById.get(val.id);
      const isPotentiallyModifiedRow =
        val?.id === updatedRow?.id ||
        val?.addEditRow === true ||
        val?.isRecordModifiedOrNew === true ||
        val?.addedAsNew === true;
      if (isRow) {
        ll_return = isPotentiallyModifiedRow
          ? uf_PQASRowChanged(val, orgObj2)
          : false;
      } else {
        ll_return = changedUpdatedRow;
      }
      // Fast path for unchanged rows during row-edit recalc:
      // keep aggregate math identical, skip expensive change-detection branching.
      if (
        isRow &&
        !isPotentiallyModifiedRow &&
        val.ll_inv_rec_seq_num !== il_rpsn
      ) {
        ll_find = idsDeallocSet.has(val.drugdrugSeqNum);
        if (!ll_find) {
          ll_pqas_drug_paid_this_transaction_amt = parseFloat(
            val.paidThisTransactionAmt
          ).toFixed(2);
          ldbl_TotPrin += parseFloat(
            ll_pqas_drug_paid_this_transaction_amt || 0
          );
        }
        updatedPqas.push(val);
        return;
      }
      // 3.6
      if (val.ll_inv_rec_seq_num === il_rpsn || ll_return) {
        // 3.6.1
        ldbl_Tmp = val.ccInterestAllocated;
        // 3.6.2
        if (ldbl_Tmp !== null) {
          ldbl_Int = Number(ldbl_Int) + Number(ldbl_Tmp);
        }

        let ldwis_CS = false;
        // 3.6.3.1
        if (
          val.addedAsNew ||
          !isPqasArrModified //isPqasModified(_.cloneDeep(pqasData), _.cloneDeep(orgPqas))
        ) {
          ldwis_CS = true;
        }

        // 3.6.3.2.	IF row is newly inserted or data modified
        const orgRow = orgById.get(val.id);
        if (ldwis_CS) {
          if (
            val?.interestSettledInd != orgRow?.interestSettledInd ||
            val?.ccInterestAllocated != orgRow?.ccInterestAllocated
          ) {
            // if data modified
            lb_IntMod = true;
          }
        } else if (
          !isPqasArrModified //isPqasModifiedExcept2(_.cloneDeep(pqasData), _.cloneDeep(orgPqas))
        ) {
          lb_OneMod = true;
        }

        // 3.6.5
        if (val.ll_inv_rec_seq_num === il_rpsn) {
          lb_OneMod = true;
        }
      }

      ll_find = idsDeallocSet.has(val.drugdrugSeqNum);

      // 3.8
      if (
        ll_return &&
        // il_rpsn !== val.ll_inv_rec_seq_num && // TBD
        lb_OneMod
      ) {
        // 3.8.1
        ll_pqas_drug_paid_this_transaction_amt = parseFloat(
          val.paidThisTransactionAmt
        ).toFixed(2);
        // 3.8.2
        ldbl_Tmp = parseFloat(ll_pqas_drug_paid_this_transaction_amt);
        // 3.8.3
        if (ldbl_Tmp !== null) {
          ldbl_OthPrin2 += parseFloat(ldbl_Tmp || 0);
        }
      }
      // 3.9 TBD
      ll_find = idsDeallocSet.has(val.drugdrugSeqNum);
      // 3.10
      if (ll_find) {
        ldbl_TotPrin += 0;
      } else {
        // 3.11.1
        ll_pqas_drug_paid_this_transaction_amt = parseFloat(
          val.paidThisTransactionAmt
        ).toFixed(2);
        // 3.11.2
        ldbl_TotPrin += parseFloat(ll_pqas_drug_paid_this_transaction_amt || 0);
      }
      updatedPqas.push(val);
    });
  }
  // end of loop

  // 4
  let {
    ldblOthInt: ldbl_OthInt,
    ldblOthPrin: ldbl_OthPrin,
    ldblIntPaidForOtherPQASQuarters: ldbl_IntPaidForOtherPQASQuarters,
    ldblPrinPaidForOtherPQASQuarters: ldbl_PrinPaidForOtherPQASQuarters,
  } = recalcResult;

  // 5
  if (ldbl_OthInt === null) {
    ldbl_OthInt = 0;
  }
  // 6
  if (ldbl_OthPrin === null) {
    ldbl_OthPrin = 0;
  }
  // 7
  if (ldbl_PrinPaidForOtherPQASQuarters === null) {
    ldbl_PrinPaidForOtherPQASQuarters = 0;
  }
  // 8
  if (ldbl_IntPaidForOtherPQASQuarters === null) {
    ldbl_IntPaidForOtherPQASQuarters = 0;
  }
  // 9
  if (pqasData.length < 1) {
    ldbl_TotPrin = 0;
  } else {
    // 10
    let temp = [...pqasData];
    temp = temp.filter((item) => item.interestSettledInd === 1);
    const sum = temp.reduce((accumulator, obj) => {
      const value = parseFloat(obj.interestCalc || 0);
      return accumulator + value;
    }, 0);
    ldbl_IntStld = parseFloat(sum).toFixed(2);
  }
  // 11
  if (ldbl_IntStld === null) {
    ldbl_IntStld = 0;
  }
  // 12
  if (ldbl_OthPrin2 !== null) {
    ldbl_TotPrin = parseFloat(ldbl_OthPrin2 || 0);
  }
  // 13 - 14
  if (hasSummaryRows) {
    const newObj =
      pqasData2?.length > 0 ? JSON.parse(JSON.stringify(pqasData2)) : [];
    const displayedRows =
      newObj &&
      newObj?.map((item) => {
        item.paidThisTransactionAmt = item?.paidThisTransactionAmt
          ? parseFloat(
              item?.paidThisTransactionAmt?.toString()?.replace(',', '').trim()
            )
          : 0;
        return item;
      });
    const newData = displayedRows?.reduce((a, b) => {
      return (
        a +
        (b?.paidThisTransactionAmt
          ? parseFloat(b?.paidThisTransactionAmt || 0)
          : 0)
      );
    }, 0);

    ldbl_PrevPrin = convertFloatFix('paidThisTransactionAmt', newData, null);
  } else {
    ldbl_PrevPrin = 0;
  }

  // 15
  if (ldbl_Int !== 0) {
    ll_interest_paid = parseFloat(sumGrid[0].totalIntPaid || 0);
    if (ll_interest_paid !== ldbl_Int) {
      ll_interest_paid = parseFloat(sumGrid[0].ldbl_Int || 0);
    }
  } else {
    // 16
    if (hasSummaryRows) {
      ldbl_Int = parseFloat(sumGrid[0].totalIntPaid || 0);
    }
    if (ldbl_Int === null) {
      // 16.2
      ldbl_Int = 0;
    }
  }
  // 17
  if (hasSummaryRows) {
    // 17.1
    ll_tot_interest_paid = parseFloat(sumGrid[0].totalIntPaid || 0);
    // 17.2 & 17.3
    if (
      parseFloat(ll_tot_interest_paid || 0) !==
      parseFloat(parseFloat(ldbl_OthInt || 0) + parseFloat(ldbl_Int || 0))
    ) {
      tot_interest_paid = parseFloat(
        parseFloat(ldbl_OthInt || 0) + parseFloat(ldbl_Int || 0)
      );
    }
    // 17.4
    ll_principal_paid = parseFloat(sumGrid[0].principalPaidThisCheck || 0);
    // 17.5
    ll_tot_principal_paid = parseFloat(sumGrid[0].totalPrincipalPaid || 0);
    // 17.6
    ll_tot_interest_alloc = parseFloat(sumGrid[0].totalIntSettled || 0);
    // 17.7 & 17.8
    const total = parseFloat(
      parseFloat(ll_principal_paid || 0) +
        parseFloat(ll_tot_principal_paid || 0) +
        parseFloat(ll_tot_interest_alloc || 0)
    );
    const total1 = parseFloat(
      parseFloat(ldbl_Prin || 0) +
        parseFloat(ldbl_TotPrin || 0) +
        parseFloat(ldbl_IntStld || 0)
    );
    if (total !== total1) {
      // 17.8.1 to 17.8.3

      summaryObj.principalPaidThisCheck = parseFloat(ldbl_Prin || 0);
      summaryObj.totalPrincipalPaid = parseFloat(ldbl_TotPrin || 0);
      summaryObj.totalIntSettled = parseFloat(ldbl_IntStld || 0);
    }
    // 17.9 & 17.10
    if (dw_pqas.length > 0) {
      // const cf_sum_owed_amt = calculateTotalSum('cfSumOwedAmt', pqasData); // TBD
    } else {
      ldbl_Tmp2 = 0;
    }
    // 17.11
    ll_tot_curr_qtr_amt = parseFloat(summaryObj.currentPrincipalAmt || 0);
    // 17.12 & 17.13
    if (ll_tot_curr_qtr_amt !== ldbl_Tmp2) {
      summaryObj.currentPrincipalAmt = ldbl_Tmp2;
    }
  }
  // 18
  ll_getPrin = uf_getprin_ROSI(rosiSumGrid || 0);
  // 19
  ll_getInt = uf_getint_ROSI(rosiSumGrid || 0);
  // 20

  ldbl_Prin = parseFloat(
    parseFloat(ll_getPrin || 0) + parseFloat(ldbl_PrevPrin || 0)
  )?.toFixed(2);
  // 21
  const intPaidSum = (Array.isArray(pqasData) ? pqasData : []).reduce(
    (accumulator, obj) => {
      const value =
        typeof obj.ccInterestAllocated === 'string'
          ? parseInt(obj.ccInterestAllocated)
          : obj.ccInterestAllocated;
      return accumulator + value;
    },
    0
  );
  ldbl_Int = parseFloat(
    parseFloat(ll_getInt) + parseFloat(intPaidSum)
  )?.toFixed(2);
  // 22
  ldbl_Prin = parseFloat(
    parseFloat(ldbl_Prin || 0) +
      parseFloat(ldbl_PrinPaidForOtherPQASQuarters || 0)
  )?.toFixed(2);
  // 23
  ldbl_Int = parseFloat(
    parseFloat(ldbl_Int) + parseFloat(ldbl_IntPaidForOtherPQASQuarters)
  )?.toFixed(2);
  // 24
  if (ab_now) {
    wf_SetPaid(params, ldbl_Prin, ldbl_Int);
  }

  // 26
  if (ab_Init) {
    summaryObj.statusCd = 'NotModified';
  }

  // 27
  const ib_RecalcPosted = false;
  SummaryRecall(
    updatedPqas,
    allocatePaymentHeaderDetail,
    [summaryObj],
    pqasAllSummaryGridList,
    dispatch,
    activeInvNum,
    activeCheckLogNum,
    disabledIntPaidAllPQAS,
    headerAllocatePaymentData,
    orgData
  );

  pqasGridData[`${activeInvNum}-${activeCheckLogNum}`] = updatedPqas;
  dispatch(
    dispatchGetPqasGridAp2({
      list: pqasGridData,
      headerData: allocatePaymentHeaderDetail,
      isUpdateData: isUpdateData,
    })
  );

  // 25
  if (!ab_now) {
    wf_SetPaid(params, ldbl_Prin, ldbl_Int);
  }
  console.timeEnd('ue_Recalc');
};

const wf_SetPaid = (params, adbl_Paid = 0, adbl_Int = 0) => {
  const {
    setPaidResult,
    allocatePaymentHeaderDetail,
    setAllocateDetailObj,
    pqasData,
    orgData,
    rosiData,
  } = params;
  let ldbl_TP = 0;
  let ldbl_TI = 0;
  let ldbl_Total = 0;
  const ll_check_log_check_amt = parseFloat(
    allocatePaymentHeaderDetail.checkAmt || 0
  ); // 5
  const ldbl_Curr = parseFloat(
    allocatePaymentHeaderDetail?.totAllocatedAmt || 0
  ); // 3
  const lds_Tot = Array.isArray(setPaidResult) ? setPaidResult : [];
  const ll_row = lds_Tot.length;
  let ib_Asked = null;
  // 2
  if (ll_row > 0) {
    ldbl_TP = lds_Tot.reduce(
      (acc, obj) => acc + parseFloat(obj.principalPaidAmt),
      0
    );
    ldbl_TI = lds_Tot.reduce(
      (acc, obj) => acc + parseFloat(obj.interestPaidAmt),
      0
    );
    ldbl_Total = ldbl_TP + ldbl_TI;
  } else {
    ldbl_Total = 0;
  }
  parseFloat(adbl_Int || 0);
  const ldbl_ToSet = parseFloat(
    parseFloat(adbl_Paid || 0) +
      parseFloat(ldbl_Total || 0) +
      parseFloat(adbl_Int || 0)
  )?.toFixed(2);
  // 4
  if (ldbl_ToSet != ldbl_Curr) {
    setAllocateDetailObj((prev) => ({
      ...prev,
      totalAllocateAmount: ldbl_ToSet,
    }));
  }
  // 6-7
  const ldbl_CA = parseFloat(ll_check_log_check_amt)?.toFixed(2);
  const ldbl_A = ldbl_ToSet;
  // 8
  if (ldbl_CA == ldbl_A) {
    wf_askalloc(ib_Asked, params, false);
  } else {
    ib_Asked = false;
  }

  let rosiData_ = Array.isArray(rosiData) ? rosiData : [];
  rosiData_ = rosiData_.filter((e) => e.isRecordModifiedOrNew);
  const rosi_ib_callsave = rosiData_.length;
  const pqas_ib_callsave = checkAddEditRow(pqasData);
  // const pqas_ib_callsave = !isPqasModified(
  //   _.cloneDeep(pqasData),
  //   _.cloneDeep(orgData)
  // );

  if (rosi_ib_callsave || pqas_ib_callsave) {
    params.rosi_ib_callsave = rosi_ib_callsave;
    params.pqas_ib_callsave = pqas_ib_callsave;
    wf_Save(params, false);
  }
};

const wf_Save = (params, action) => {
  const { rosi_ib_callsave, pqas_ib_callsave, saveAllocateDetail } = params;
  const ab_asksave = action;
  if (!rosi_ib_callsave || !pqas_ib_callsave) {
    return 1;
  }
  if (ab_asksave) {
    // will never execute
  } else {
    saveAllocateDetail();
  }
};

const wf_askalloc = (ib_Asked, params, temp) => {
  const { setModal } = params;
  let ib_PQASMoving = false;
  if (ib_Asked) {
    return false;
  }
  if (ib_PQASMoving) {
    ib_PQASMoving = false;
    return false;
  }
  ib_Asked = true;
  setModal({
    open: true,
    title: 'ROSI/PQAS',
    closeTitle: 'No',
    message:
      'This check has been fully allocated, would you like to Declare the Check Allocated and close the window?',
  });
};

const uf_getprin_ROSI = (sumGrid) => {
  // if (sumGrid.length <= 0) {
  //   return0
  // }
  let ldbl_Prin = parseFloat(
    sumGrid && sumGrid.length === 0 ? 0 : sumGrid[0].principalPaid
  );
  if (ldbl_Prin === null) ldbl_Prin = 0;
  return ldbl_Prin;
};

const uf_getint_ROSI = (sumGrid) => {
  // if (sumGrid.length <= 0) {
  //   return0
  // }
  let ldbl_Int = parseFloat(
    sumGrid && sumGrid.length === 0 ? 0 : sumGrid[0].totalIntPaid
  );
  if (ldbl_Int === null) ldbl_Int = 0;
  return ldbl_Int;
};

const uf_PQASRowChanged = (obj, orgObj) => {
  if (!obj || !orgObj) return true;
  return !compareObjects(obj, orgObj);
};

// Mark Int Settled For All

const uf_getint_PQAS = (sumGrid = []) => {
  const ldbl_Int = sumGrid[0]?.totalIntPaid;
  if (sumGrid.length <= 0) {
    return 0;
  }
  return ldbl_Int || 0;
};

const uf_checkinterestonly = (
  row,
  condition1,
  prevIntPaid = '',
  currIntPaid = ''
) => {
  let lb_noMod = true;

  if (condition1) {
    lb_noMod = true;
  } else {
    lb_noMod = false;
  }

  // if (condition2) {

  //   lb_noMod = false;
  //   // return lb_noMod;
  // }

  // 3.1.1
  row.ldc_PTTA = parseFloat(row.paidThisTransactionAmt).toFixed(2);
  if (row.addedAsNew) {
    // 3.1.2 IF current row is newly inserted row OR column value is modified
    if (row.hasOwnProperty('interestSettledInd')) {
      lb_noMod = false;
      return lb_noMod;
    }
  } else if (row.ldc_PTTA > 0) {
    lb_noMod = false;
    return lb_noMod;
  }
  return lb_noMod;
};

export const uf_markInterestSettled = (row, currUnitsPaid, paidAmnt) => {
  let lb_flag = true;
  if (currUnitsPaid == 0 || currUnitsPaid == null) {
    lb_flag = false;
    return lb_flag;
  }
  if (paidAmnt == 0 || paidAmnt == null) {
    lb_flag = false;
    return lb_flag;
  }
  if (row.isMarkInt) {
    if (row.dupPaidUnits == 0 || row.dupPaidUnits == null) {
      if (row.dupPaidUnits == currUnitsPaid) {
        lb_flag = false;
        return lb_flag;
      }
      if (row.dupPaidUnits == null) {
        lb_flag = false;
        return lb_flag;
      }
    }
  } else {
    if (row.paidUnits == 0 || row.paidUnits == null) {
      if (row.paidUnits == currUnitsPaid) {
        lb_flag = false;
        return lb_flag;
      }
      if (row.paidUnits == null) {
        lb_flag = false;
        return lb_flag;
      }
    }
  }

  return lb_flag;
};
export const removeWhiteSpaceForNDC = (val) => {
  return val?.toString()?.split('//')[0];
};
export const markIntSettled = (
  obj,
  sumGrid = [],
  pqasGridData = [],
  pqasOriginal = [],
  preValues,
  allocatePaymentHeaderDetail,
  dispatch,
  updateDetailsAllData,
  getPreInitData,
  activeInvNum,
  activeCheckLogNum,
  gridParams,
  setRowData
) => {
  // 1
  let ldc_IntPaid = uf_getint_PQAS(sumGrid);
  let lb_checked = null;
  let ib_RecalcPosted = null;
  const pqasData = _.cloneDeep(pqasGridData);

  if (ldc_IntPaid === null) {
    ldc_IntPaid = 0;
  }

  let pqasOrg = _.cloneDeep(pqasOriginal);
  let pqasTemp = _.cloneDeep(pqasGridData);
  const arr1 = pqasTemp
    .sort((a, b) => (a.ndc > b.ndc ? 1 : -1))
    .map((item) => item?.interestSettledInd);
  const arr2 = _.cloneDeep(pqasOriginal)
    .sort((a, b) => (a.ndc > b.ndc ? 1 : -1))
    .map((item) => item?.interestSettledInd);
  const isInterestSettledInd = JSON.stringify(arr1) !== JSON.stringify(arr2);
  _.forEach(pqasTemp, (v, i) => {
    if (v.summaryGridCheck) {
      v.addEditRow = v.addEditRow;
      v.bgColorForCcInterestAllocated = colorCode.whiteCd;
      v.disabledForCcInterestAllocated = false;
      delete v.summaryGridCheck;
    }
    return v;
  });
  // uf_checkinterestonly first two conditions
  let condition1;
  if (pqasTemp?.length != pqasOrg?.length) {
    const pqasTempFilter = pqasTemp?.filter((obj) => obj.addedAsNew === true);
    const hasPaidAmount = pqasTempFilter?.some((obj) =>
      parseFloat(obj.paidThisTransactionAmt)
    );
    if (hasPaidAmount) {
      condition1 = false;
    } else {
      const pqasTempFilterNoAdded = pqasTemp?.filter(
        (obj) => obj.addedAsNew != true
      );
      condition1 =
        isPqasModified(pqasTempFilterNoAdded, pqasOrg) ||
        (isInterestSettledInd &&
          isPqasModifiedExcept(pqasTempFilterNoAdded, pqasOrg));
    }
  } else {
    condition1 =
      isPqasModified(pqasTemp, pqasOrg) ||
      (isInterestSettledInd && isPqasModifiedExcept(pqasTemp, pqasOrg));
  }
  let allObjs = [];
  const il_RPSN = allocatePaymentHeaderDetail?.recancilationNumber
    ? allocatePaymentHeaderDetail?.recancilationNumber
    : allocatePaymentHeaderDetail?.reconciliationNumber;
  for (let row = 0; row < pqasData.length; row += 1) {
    let newRows = {};
    const lb_intOnly = uf_checkinterestonly(pqasData[row], condition1, '', '');
    // 8.1
    pqasData[row].ll_rpsn = pqasData[row].invRecSeqNum;
    pqasData[row].ll_dsn = pqasData[row].drugdrugSeqNum;
    pqasData[row].ldc_paidUnits = pqasData[row].currUnitsPaid;
    pqasData[row].ldc_paidAmnt = parseFloat(
      pqasData[row].paidThisTransactionAmt
    ).toFixed(2);
    pqasData[row].ldc_intCalc = parseFloat(pqasData[row].interestCalc || 0);

    // 8.2
    if (
      pqasData[row].ll_rpsn !== il_RPSN && pqasData[row].ll_rpsn !== 0
    ) {
      if (
        !(
          pqasData?.filter((x) => {
            return (
              x.id !== pqasData[row].id &&
              removeWhiteSpaceForNDC(x.ndc) ===
                removeWhiteSpaceForNDC(pqasData[row].ndc)
            );
          }).length > 0
        )
      ) {
        const is_ndc = pqasData[row].ndc;
        const { labelerCode } = pqasData[row];
        if (!is_ndc.includes(labelerCode)) {
          pqasData[row].ndc = `${labelerCode}-${is_ndc}`;
        }
        if (!condition1) {
          pqasData[row].dupCurrUnitsPaid = pqasData[row].currUnitsPaid;
          pqasData[row].dupPaidUnits = pqasData[row].paidUnits;
          pqasData[row].dupPaidThisTransactionAmt =
            pqasData[row].paidThisTransactionAmt;
          pqasData[row].currUnitsPaid = parseFloat(0).toFixed(3);
          pqasData[row].paidUnits = parseFloat(0).toFixed(3);
          // pqasData[row].paidThisTransactionAmt = parseFloat(0).toFixed(2);
          pqasData[row].isMarkInt = true;
        }
        // if(pqasData[row].interestSettledInd === 1) {
        //   pqasData[row].interestSettledInd = 0
        // }
        newRows = { ...pqasData[row] };
      }
    }

    if (lb_intOnly) {
      lb_checked = true;
    } else {
      if (pqasData[row]?.isMarkInt) {
        lb_checked = uf_markInterestSettled(
          pqasData[row],
          pqasData[row].dupCurrUnitsPaid,
          pqasData[row].dupPaidThisTransactionAmt
        );
      } else {
        lb_checked = uf_markInterestSettled(
          pqasData[row],
          pqasData[row].currUnitsPaid,
          pqasData[row].paidThisTransactionAmt
        );
      }
    }

    if (condition1) {
      if (
        pqasData[row].interestSettledInd !== 1 &&
        (pqasData[row].bgColorForNDC === '12632256' ||
          pqasData[row].bgColorForNDC === '00b300')
      ) {
        pqasData[row].interestSettledInd = 1;
        pqasData[row].markIntsettle = true;
        pqasData[row].addEditRow = true;
      }
    } else if (
      lb_checked &&
      pqasData[row].interestSettledInd !== 1 &&
      (pqasData[row].bgColorForNDC === '12632256' ||
        pqasData[row].bgColorForNDC === '00b300')
    ) {
      pqasData[row].interestSettledInd = 1;
      pqasData[row].markIntsettle = true;
      pqasData[row].addEditRow = true;
    }
    // 8.6
    if (Object.keys(newRows).length > 0 && newRows.interestSettledInd !== 1) {
      // gray 12632256
      // yellow 11534335
      if (lb_checked) {
        newRows.interestSettledInd = 1;
        newRows.bgColorForNDC = '12632256';
        newRows.bgColor = '12632256';
        newRows.ldc_IntCalc = newRows.ccInterestowed;
        newRows.ldc_CurrUnits = newRows.currUnits;
        newRows.markIntsettle = true;
        newRows.addEditRow = true;
      } else {
        newRows.bgColorForNDC = '12632256';
        newRows.bgColor = '12632256';
        newRows.addEditRow = true;
      }
    } else if (
      Object.keys(newRows).length > 0 &&
      newRows.interestSettledInd === 1
    ) {
      newRows.interestSettledInd = 0;
      newRows.bgColorForNDC = '12632256';
      newRows.bgColor = '12632256';
      newRows.ldc_IntCalc = newRows.ccInterestowed;
      newRows.ldc_CurrUnits = newRows.currUnits;
      newRows.markIntsettle = true;
      newRows.addEditRow = true;
    }
    allObjs.push(newRows);
  }
  allObjs = allObjs.filter((obj) => Object.keys(obj).length !== 0);
  const newPqasGridRows = addDuplicateNdc(
    _.cloneDeep(allObjs),
    _.cloneDeep(pqasData),
    allocatePaymentHeaderDetail,
    getPreInitData,
    true,
    false
  );
  handleAddNDCRow(
    _.cloneDeep(allObjs),
    _.cloneDeep(pqasData),
    allocatePaymentHeaderDetail,
    dispatch,
    getPreInitData,
    updateDetailsAllData,
    activeInvNum,
    activeCheckLogNum,
    true,
    true,
    gridParams,
    setRowData
  );
  ib_RecalcPosted = true;
  obj.pqasData = newPqasGridRows;
  ue_Recalc({ ...obj }, false, false, false);
};

export const updateCurrentUraAction = async (
  row,
  dt,
  pqasData = [],
  allocatePaymentHeaderDetail,
  setUpdateUra,
  dispatch
) => {
  for (let i = 0; i < pqasData.length; i += 1) {
    // 2
    const getSelectedRow = _.filter(row, (l) => (l.id = pqasData[i].id));
    if (!_.isEmpty(getSelectedRow)) {
      pqasData[i].ldc_PaidAmount = parseFloat(
        pqasData[i].paidThisTransactionAmt || 0
      ).toFixed(2); // 2.1
      if (
        pqasData[i].ldc_PaidAmount === null ||
        parseFloat(pqasData[i].ldc_PaidAmount) === 0 ||
        pqasData[i].ldc_PaidAmount === '0'
      ) {
        // 2.2
        const params = {
          llDsn: pqasData[i]?.drugdrugSeqNum,
          isPrevQTR: pqasData[i]?.prevQtr,
          idtCheckDate: dt?.selectedRow?.checkDt,
        }; // 2.2.1
        const result = await dispatch(getIdcCurrUra(params)); // 2.2.2
        let ldc_CurrURA = result?.payload?.ldcCurrURA;
        if (ldc_CurrURA === null) {
          ldc_CurrURA = 0; // 2.2.3
          // } else {
        }
        pqasData[i].currUnitRebateAmt = ldc_CurrURA; // 2.2.4
        let ldc_CurrUnits = pqasData[i].currUnits; // 2.2.5
        if (ldc_CurrUnits === null) {
          ldc_CurrUnits = 0; // 2.2.6
        }
        let ldc_CurrUnitsPaid = pqasData[i].currUnitsPaid; // 2.2.7
        if (ldc_CurrUnitsPaid === null) {
          ldc_CurrUnitsPaid = 0; // 2.2.8
        }
        let ldc_CurrAmtPaid = pqasData[i].currAmtPaid; // 2.2.9
        if (ldc_CurrAmtPaid === null) {
          ldc_CurrAmtPaid = 0; // 2.2.10
        }
        let ldc_PriorAmtPaid = pqasData[i].priorPaidAmt; // 2.2.11
        if (ldc_PriorAmtPaid === null) {
          ldc_PriorAmtPaid = 0; // 2.2.12
        }
        let ldc_CurrUnitsDisputed = pqasData[i].currUnitsDisputed; // 2.2.13
        if (ldc_CurrUnitsDisputed === null) {
          ldc_CurrUnitsDisputed = 0; // 2.2.14
        }
        // pqasData[i].revisedInvoiceAmt = parseFloat(
        //   ldc_CurrURA * ldc_CurrUnits
        // ).toFixed(2);
        pqasData[i].revisedInvoiceAmt = roundOffAmt(
          parseFloat(ldc_CurrURA || 0) * parseFloat(ldc_CurrUnits || 0)
        ); // 2.2.15
        // 2.2.16
        if (
          (ldc_CurrUnits !== 0 && ldc_CurrUnits === ldc_CurrUnitsDisputed) ||
          ldc_CurrUnitsPaid > 0
        ) {
          // 2.2.16
          // pqasData[i].currAmtPaid = parseFloat(
          //   ldc_CurrURA * ldc_CurrUnitsPaid
          // ).toFixed(2); // 2.2.16.1
          pqasData[i].currAmtPaid = roundOffAmt(
            parseFloat(ldc_CurrURA || 0) * parseFloat(ldc_CurrUnitsPaid || 0)
          );
          pqasData[i].paidThisTransactionAmt = parseFloat(
            ldc_CurrAmtPaid - ldc_PriorAmtPaid
          ).toFixed(2); // 2.2.16.2
        }
      }
    }
  }
  dispatch(
    dispatchGetPqasGridAp2({
      list: pqasData,
      headerData: allocatePaymentHeaderDetail,
      isUpdateData: false,
    })
  );
  setUpdateUra(true);
};
// check NDC is modified or not
const hasNDCObjChanged = (obj1, obj2) => {
  return (
    parseFloat(obj1.interestSettledInd) !==
      parseFloat(obj2.interestSettledInd) ||
    parseFloat(obj1.ccInterestAllocated) !==
      parseFloat(obj2.ccInterestAllocated) ||
    parseFloat(obj1.ccPaidInFullInd) !== parseFloat(obj2.ccPaidInFullInd) ||
    parseFloat(obj1.currUnitRebateAmt) !== parseFloat(obj2.currUnitRebateAmt) ||
    parseFloat(obj1.currUnits) !== parseFloat(obj2.currUnits) ||
    parseFloat(obj1.priorPaidUnits) !== parseFloat(obj2.priorPaidUnits) ||
    parseFloat(obj1.currUnitsPaid) !== parseFloat(obj2.currUnitsPaid) ||
    parseFloat(obj1.priorDisputedUnits) !==
      parseFloat(obj2.priorDisputedUnits) ||
    parseFloat(obj1.priorPaidAmt) !== parseFloat(obj2.priorPaidAmt) ||
    parseFloat(obj1.currAmtPaid) !== parseFloat(obj2.currAmtPaid) ||
    parseFloat(obj1.paidThisTransactionAmt) !==
      parseFloat(obj2.paidThisTransactionAmt) ||
    parseFloat(obj1.ccAc1) !== parseFloat(obj2.ccAc1) ||
    parseFloat(obj1.ccAc2) !== parseFloat(obj2.ccAc2) ||
    parseFloat(obj1.ccAc3) !== parseFloat(obj2.ccAc3) ||
    parseFloat(obj1.ccDc1) !== parseFloat(obj2.ccDc1) ||
    parseFloat(obj1.ccDc2) !== parseFloat(obj2.ccDc2) ||
    parseFloat(obj1.ccDc3) !== parseFloat(obj2.ccDc3)
  );
};
// to check isPqasTabModified
export const isPqasColModifed = (obj1, obj2) => {
  const returnValue = hasNDCObjChanged(obj1, obj2);
  return returnValue;
};
const checkAddEditRow = (data) => {
  return !data?.some((item) => item.addEditRow === true);
};
export const isPqasModified = (pqasGridData = [], pqasOriginal = []) => {
  if (!Array.isArray(pqasGridData) || pqasGridData.length === 0) {
    return true;
  }
  const editedRows = pqasGridData.filter((row) => row?.addEditRow);
  if (editedRows.length === 0) {
    return true;
  }
  const ignoreKeys = new Set([
    'addEditRow',
    'cfSumOwedAmt',
    'disabledForCcInterestAllocated',
    'bgColorForCcInterestAllocated',
  ]);
  const originalById = new Map(
    (pqasOriginal || []).map((row) => [row?.id, row])
  );
  return editedRows.every((row) => {
    const original = originalById.get(row?.id);
    if (!original) return false;
    const keys = new Set([
      ...Object.keys(row || {}),
      ...Object.keys(original || {}),
    ]);
    for (const key of keys) {
      if (ignoreKeys.has(key)) continue;
      if (row?.[key] != original?.[key]) return false;
    }
    return true;
  });
};

export const isPqasModifiedExcept = (
  // Except interestSettledInd
  pqasGridData = [],
  pqasOriginal = []
) => {
  if (!Array.isArray(pqasGridData) || pqasGridData.length === 0) {
    return true;
  }
  const editedRows = pqasGridData.filter((row) => row?.addEditRow);
  if (editedRows.length === 0) {
    return true;
  }
  const ignoreKeys = new Set([
    'addEditRow',
    'cfSumOwedAmt',
    'interestSettledInd',
    'disabledForCcInterestAllocated',
    'bgColorForCcInterestAllocated',
  ]);
  const originalById = new Map(
    (pqasOriginal || []).map((row) => [row?.id, row])
  );
  return editedRows.every((row) => {
    const original = originalById.get(row?.id);
    if (!original) return false;
    const keys = new Set([
      ...Object.keys(row || {}),
      ...Object.keys(original || {}),
    ]);
    for (const key of keys) {
      if (ignoreKeys.has(key)) continue;
      if (row?.[key] != original?.[key]) return false;
    }
    return true;
  });
};

export const isPqasModifiedExcept2 = (
  // Except interestSettledInd & ccInterestAllocated
  pqasGridData = [],
  pqasOriginal = []
) => {
  if (!Array.isArray(pqasGridData) || pqasGridData.length === 0) {
    return true;
  }
  const editedRows = pqasGridData.filter((row) => row?.addEditRow);
  if (editedRows.length === 0) {
    return true;
  }
  const ignoreKeys = new Set([
    'addEditRow',
    'cfSumOwedAmt',
    'interestSettledInd',
    'disabledForCcInterestAllocated',
    'bgColorForCcInterestAllocated',
    'ccInterestAllocated',
  ]);
  const originalById = new Map(
    (pqasOriginal || []).map((row) => [row?.id, row])
  );
  return editedRows.every((row) => {
    const original = originalById.get(row?.id);
    if (!original) return false;
    const keys = new Set([
      ...Object.keys(row || {}),
      ...Object.keys(original || {}),
    ]);
    for (const key of keys) {
      if (ignoreKeys.has(key)) continue;
      if (row?.[key] != original?.[key]) return false;
    }
    return true;
  });
};

export const convertFloatFix = (col, value, toFixed) => {
  let val = parseFloat(
    removeDollarForNumberFiled(removeCommaForNumberFiled(value)) || 0
  );
  if (!toFixed) {
    if (
      _.includes(
        [
          'ccInterestAllocated',
          'interestCalc',
          'xorigAmtPtt',
          'revisedInvoiceAmt',
          'priorPaidAmt',
          'currAmtPaid',
          'paidThisTransactionAmt',
        ],
        col
      )
    ) {
      val = val?.toFixed(2);
    }
    if (
      _.includes(
        [
          'currUnits',
          'xorigCurrUnitsPaid',
          'totReimbursedUnits',
          'priorPaidUnits',
          'currUnitsPaid',
          'priorDisputedUnits',
          'currUnitsDisputed',
        ],
        col
      )
    ) {
      val = val?.toFixed(3);
    }
    if (_.includes(['cidunitRebateAmt', 'currUnitRebateAmt'], col)) {
      val = val?.toFixed(6);
    }
  } else {
    val = isNaN(val) ? parseFloat(0)?.toFixed(toFixed) : val?.toFixed(toFixed);
  }
  return isNaN(val) ? parseFloat(0)?.toFixed(toFixed) : val;
};

export const checkDifferentProperties = (arr1, arr2) => {
  let arr1Temp = _.cloneDeep(arr1);
  let arr2Temp = _.cloneDeep(arr2);
  const result = [];
  if (!_.isEmpty(arr1Temp) && !_.isEmpty(arr2Temp)) {
    arr1Temp = arr1Temp.map((item) => {
      delete item.addEditRow;
      delete item.cfSumOwedAmt;
      delete item.disabledForCcInterestAllocated;
      delete item.bgColorForCcInterestAllocated;
      return item;
    });
    arr2Temp = arr2Temp.map((item) => {
      delete item.addEditRow;
      delete item.cfSumOwedAmt;
      delete item.disabledForCcInterestAllocated;
      delete item.bgColorForCcInterestAllocated;
      return item;
    });

    arr1Temp.forEach((obj1) => {
      const obj2 = arr2Temp.find((obj) => obj.id === obj1.id);

      if (obj2) {
        for (const prop in obj1) {
          if (obj1[prop] !== obj2[prop]) {
            result.push({
              id: obj1.id,
              property: prop,
              value1: obj1[prop],
              value2: obj2[prop],
            });
          }
        }
      }
    });
  }

  return result;
};

export const areObjectsEqual = (obj1, obj2) => {
  if (Object.keys(obj1).length !== Object.keys(obj2).length) {
    return false;
  }
  for (const key in obj1) {
    if (obj1[key] !== obj2[key]) {
      return false;
    }
  }
  return true;
};

const compareObjects = (obj1, obj2) => {
  for (const key in obj1) {
    if (obj1.hasOwnProperty(key) && obj2.hasOwnProperty(key)) {
      if (obj1[key] != obj2[key]) {
        return false;
      }
    }
  }
  return true;
};

export const rowColorAndEnbleDiableLogic = (list, recancilationNumber) => {
  const newData = _.cloneDeep(list);
  if (!_.isEmpty(newData)) {
    if (newData.ccRowSource === 'ADDORIG') {
      newData.disabledForCcInterestAllocated = false;
      newData.isAllowFormatterCcInterestAllocated = false;
      newData.isAllowFormatterInterestCalc = false;
      newData.isAllowFormatterPriorPaidAmt = false;
      newData.isAllowFormatterCurrAmtPaid = false;
      newData.isAllowFormatterPaidThisTransactionAmt = false;
      newData.bgColorForCcInterestAllocated = colorCode.whiteCd;
      newData.disabledForInterestCalc = true;
      newData.disabledForOrgURA = true;
      newData.disabledForOrgUnitsInv = true;
      newData.disabledForRevisedInvAmt = true;
      newData.autoFocusCcAc1 = false;
      newData.autoFocusCcAc2 = false;
      newData.autoFocusCcAc3 = false;
      newData.autoFocusCcDc1 = false;
      newData.autoFocusCcDc2 = false;
      newData.autoFocusCcDc3 = false;
      newData.bgColor = '';
      if (
        newData?.ccOverridColorDis === colorCode.greenCd ||
        parseFloat(newData?.ccOverridColorDis) >= 0 ||
        newData.statusCd === 'WO' ||
        newData.statusCd === 'FG' ||
        newData.statusCd === 'DB' ||
        newData.statusCd === 'DBK'
      ) {
        newData.bgColorForInterestCalc = colorCode.greenCd;
        newData.bgColorForOrgURA = colorCode.greenCd;
        newData.bgColorForOrgUnitsInv = colorCode.greenCd;
        newData.bgColorForOrgInvAmt = colorCode.greenCd;
        newData.bgColorForRevisedInvAmt = colorCode.greenCd;
      } else {
        newData.bgColorForInterestCalc = colorCode.disGreyCd;
        newData.bgColorForOrgURA = colorCode.disGreyCd;
        newData.bgColorForOrgUnitsInv = colorCode.disGreyCd;
        newData.bgColorForOrgInvAmt = colorCode.disGreyCd;
        newData.bgColorForRevisedInvAmt = colorCode.disGreyCd;
      }
      if (
        newData?.invRecSeqNum === recancilationNumber ||
        newData?.invRecSeqNum === 0 ||
        !newData?.invRecSeqNum ||
        newData?.invRecSeqNum === null
      ) {
        newData.disabledForPaidInFullInd = false;
        newData.bgColorForPaidInFullInd = colorCode.whiteCd;
        newData.bgColorForNDC =
          newData?.ccOverridColorDis === colorCode.greenCd ||
          parseFloat(newData?.ccOverridColorDis) >= 0
            ? colorCode.greenCd
            : colorCode.disGreyCd;
        newData.bgColor =
          newData?.ccOverridColorDis === colorCode.greenCd ||
          parseFloat(newData?.ccOverridColorDis) >= 0
            ? colorCode.greenCd
            : colorCode.disGreyCd;
        if (parseFloat(newData?.ccPaidInFullInd) === 1) {
          newData.disabledForCurrURA = true;
          newData.disabledForCurrUnits = true;
          newData.disabledForCurrUnitsPaid = true;
          newData.bgColorForCurrUnitsDisputed = true;
          newData.disabledForCurrAmtPaid = true;
          newData.disabledForAmtPaidThisTran = true;
          newData.disabledForCcAc1 = true;
          newData.disabledForCcAc2 = true;
          newData.disabledForCcAc3 = true;
          newData.disabledForCcDc1 = true;
          newData.disabledForCcDc2 = true;
          newData.disabledForCcDc3 = true;
          newData.bgColorForCurrURA =
            newData?.ccOverridColorDis === colorCode.greenCd ||
            parseFloat(newData?.ccOverridColorDis) >= 0
              ? colorCode.greenCd
              : colorCode.disGreyCd;
          newData.bgColorForCurrUnits =
            newData?.ccOverridColorDis === colorCode.greenCd ||
            parseFloat(newData?.ccOverridColorDis) >= 0
              ? colorCode.greenCd
              : colorCode.disGreyCd;
          newData.bgColorForCurrAmtPaid =
            newData?.ccOverridColorDis === colorCode.greenCd ||
            parseFloat(newData?.ccOverridColorDis) >= 0
              ? colorCode.greenCd
              : colorCode.disGreyCd;
          newData.bgColorForAmtPaidThisTran =
            newData?.ccOverridColorDis === colorCode.greenCd ||
            parseFloat(newData?.ccOverridColorDis) >= 0
              ? colorCode.greenCd
              : colorCode.disGreyCd;
          newData.bgColorForCcAc1 =
            newData?.ccOverridColorDis === colorCode.greenCd ||
            parseFloat(newData?.ccOverridColorDis) >= 0
              ? colorCode.greenCd
              : colorCode.disGreyCd;
          newData.bgColorForCcAc2 =
            newData?.ccOverridColorDis === colorCode.greenCd ||
            parseFloat(newData?.ccOverridColorDis) >= 0
              ? colorCode.greenCd
              : colorCode.disGreyCd;
          newData.bgColorForCcAc3 =
            newData?.ccOverridColorDis === colorCode.greenCd ||
            parseFloat(newData?.ccOverridColorDis) >= 0
              ? colorCode.greenCd
              : colorCode.disGreyCd;
          newData.bgColorForCcDc1 =
            newData?.ccOverridColorDis === colorCode.greenCd ||
            parseFloat(newData?.ccOverridColorDis) >= 0
              ? colorCode.greenCd
              : colorCode.disGreyCd;
          newData.bgColorForCcDc2 =
            newData?.ccOverridColorDis === colorCode.greenCd ||
            parseFloat(newData?.ccOverridColorDis) >= 0
              ? colorCode.greenCd
              : colorCode.disGreyCd;
          newData.bgColorForCcDc3 =
            newData?.ccOverridColorDis === colorCode.greenCd ||
            parseFloat(newData?.ccOverridColorDis) >= 0
              ? colorCode.greenCd
              : colorCode.disGreyCd;
        } else {
          newData.disabledForCurrURA = false;
          newData.disabledForCurrUnits = false;
          newData.disabledForCurrUnitsPaid = false;
          newData.bgColorForCurrUnitsDisputed = false;
          newData.disabledForCurrAmtPaid = false;
          newData.disabledForAmtPaidThisTran = false;
          newData.disabledForCcAc1 = true;
          newData.disabledForCcAc2 = true;
          newData.disabledForCcAc3 = true;
          newData.disabledForCcDc1 = true;
          newData.disabledForCcDc2 = true;
          newData.disabledForCcDc3 = true;
          newData.bgColorForCurrURA = colorCode?.whiteCd;
          newData.bgColorForCurrUnits = colorCode?.whiteCd;
          newData.bgColorForCurrAmtPaid = colorCode?.whiteCd;
          newData.bgColorForAmtPaidThisTran = colorCode?.whiteCd;
          newData.bgColorForCcAc1 = colorCode?.whiteCd;
          newData.bgColorForCcAc2 = colorCode?.whiteCd;
          newData.bgColorForCcAc3 = colorCode?.whiteCd;
          newData.bgColorForCcDc1 = colorCode?.whiteCd;
          newData.bgColorForCcDc2 = colorCode?.whiteCd;
          newData.bgColorForCcDc3 = colorCode?.whiteCd;
        }
        if (
          parseFloat(newData?.ccPaidInFullInd) === 1 ||
          parseFloat(newData?.ccOverridePrevVals) === 0
        ) {
          newData.disabledForPriorUnitsPaid = true;
          newData.disabledForPriorUnitsDisputed = true;
          newData.disabledForPriorAmtPaid = true;
          newData.bgColorForPriorUnitsPaid =
            newData?.ccOverridColorDis === colorCode.greenCd ||
            parseFloat(newData?.ccOverridColorDis) >= 0
              ? colorCode.greenCd
              : colorCode.disGreyCd;
          newData.bgColorForPriorUnitsDisputed =
            newData?.ccOverridColorDis === colorCode.greenCd ||
            parseFloat(newData?.ccOverridColorDis) >= 0
              ? colorCode.greenCd
              : colorCode.disGreyCd;
          newData.bgColorForPriorAmtPaid =
            newData?.ccOverridColorDis === colorCode.greenCd ||
            parseFloat(newData?.ccOverridColorDis) >= 0
              ? colorCode.greenCd
              : colorCode.disGreyCd;
        } else {
          newData.disabledForPriorUnitsPaid = false;
          newData.disabledForPriorUnitsDisputed = false;
          newData.disabledForPriorAmtPaid = false;
          newData.bgColorForPriorUnitsPaid = colorCode?.whiteCd;
          newData.bgColorForPriorUnitsDisputed = colorCode?.whiteCd;
          newData.bgColorForPriorAmtPaid = colorCode?.whiteCd;
        }
        if (parseFloat(newData?.currUnitsPaid) < 0) {
          newData.bgColorForCurrUnitsPaid = colorCode.redCd;
          newData.bgColorForCurrUnitsDisputed = colorCode.redCd;
        } else if (parseFloat(newData?.ccPaidInFullInd) === 1) {
          newData.bgColorForCurrUnitsPaid =
            newData?.ccOverridColorDis === colorCode.greenCd ||
            parseFloat(newData?.ccOverridColorDis) >= 0
              ? colorCode.greenCd
              : colorCode.disGreyCd;
          newData.bgColorForCurrUnitsDisputed =
            newData?.ccOverridColorDis === colorCode.greenCd ||
            parseFloat(newData?.ccOverridColorDis) >= 0
              ? colorCode.greenCd
              : colorCode.disGreyCd;
        } else {
          newData.bgColorForCurrUnitsPaid = colorCode.whiteCd;
          newData.bgColorForCurrUnitsDisputed = colorCode.whiteCd;
        }
      } else {
        newData.disabledForPaidInFullInd = true;
        newData.disabledForCurrURA = true;
        newData.disabledForCurrUnits = true;
        newData.disabledForPriorUnitsPaid = true;
        newData.disabledForCurrUnitsPaid = true;
        newData.disabledForPriorUnitsDisputed = true;
        newData.disabledForCurrUnitsDisputed = true;
        newData.disabledForPriorAmtPaid = true;
        newData.disabledForCurrAmtPaid = true;
        newData.disabledForAmtPaidThisTran = true;
        newData.disabledForCcAc1 = true;
        newData.disabledForCcAc2 = true;
        newData.disabledForCcAc3 = true;
        newData.disabledForCcDc1 = true;
        newData.disabledForCcDc2 = true;
        newData.disabledForCcDc3 = true;
        newData.bgColorForPaidInFullInd =
          newData?.ccOverridColorDis === colorCode.greenCd ||
          parseFloat(newData?.ccOverridColorDis) >= 0
            ? colorCode.greenCd
            : colorCode.greyCd;
        newData.bgColorForNDC = colorCode.yellowCd;
        if (
          newData?.ccOverridColorDis === colorCode.greenCd ||
          parseFloat(newData?.ccOverridColorDis) >= 0 ||
          newData.statusCd === 'WO' ||
          newData.statusCd === 'FG' ||
          newData.statusCd === 'DB' ||
          newData.statusCd === 'DBK'
        ) {
          newData.bgColor = colorCode.greenCd;
        } else {
          newData.bgColor = colorCode.yellowCd;
        }
        newData.bgColorForCurrURA =
          newData?.ccOverridColorDis === colorCode.greenCd ||
          parseFloat(newData?.ccOverridColorDis) >= 0
            ? colorCode.greenCd
            : colorCode.disGreyCd;
        newData.bgColorForCurrUnits =
          newData?.ccOverridColorDis === colorCode.greenCd ||
          parseFloat(newData?.ccOverridColorDis) >= 0
            ? colorCode.greenCd
            : colorCode.disGreyCd;
        newData.bgColorForPriorUnitsPaid =
          newData?.ccOverridColorDis === colorCode.greenCd ||
          parseFloat(newData?.ccOverridColorDis) >= 0
            ? colorCode.greenCd
            : colorCode.disGreyCd;
        newData.bgColorForCurrUnitsPaid =
          newData?.ccOverridColorDis === colorCode.greenCd ||
          parseFloat(newData?.ccOverridColorDis) >= 0
            ? colorCode.greenCd
            : colorCode.disGreyCd;
        newData.bgColorForPriorUnitsDisputed =
          newData?.ccOverridColorDis === colorCode.greenCd ||
          parseFloat(newData?.ccOverridColorDis) >= 0
            ? colorCode.greenCd
            : colorCode.disGreyCd;
        newData.bgColorForCurrUnitsDisputed =
          newData?.ccOverridColorDis === colorCode.greenCd ||
          parseFloat(newData?.ccOverridColorDis) >= 0
            ? colorCode.greenCd
            : colorCode.disGreyCd;
        newData.bgColorForPriorAmtPaid =
          newData?.ccOverridColorDis === colorCode.greenCd ||
          parseFloat(newData?.ccOverridColorDis) >= 0
            ? colorCode.greenCd
            : colorCode.disGreyCd;
        newData.bgColorForCurrAmtPaid =
          newData?.ccOverridColorDis === colorCode.greenCd ||
          parseFloat(newData?.ccOverridColorDis) >= 0
            ? colorCode.greenCd
            : colorCode.disGreyCd;
        newData.bgColorForAmtPaidThisTran =
          newData?.ccOverridColorDis === colorCode.greenCd ||
          parseFloat(newData?.ccOverridColorDis) >= 0
            ? colorCode.greenCd
            : colorCode.disGreyCd;
        newData.bgColorForCcAc1 =
          newData?.ccOverridColorDis === colorCode.greenCd ||
          parseFloat(newData?.ccOverridColorDis) >= 0
            ? colorCode.greenCd
            : colorCode.disGreyCd;
        newData.bgColorForCcAc2 =
          newData?.ccOverridColorDis === colorCode.greenCd ||
          parseFloat(newData?.ccOverridColorDis) >= 0
            ? colorCode.greenCd
            : colorCode.disGreyCd;
        newData.bgColorForCcAc3 =
          newData?.ccOverridColorDis === colorCode.greenCd ||
          parseFloat(newData?.ccOverridColorDis) >= 0
            ? colorCode.greenCd
            : colorCode.disGreyCd;
        newData.bgColorForCcDc1 =
          newData?.ccOverridColorDis === colorCode.greenCd ||
          parseFloat(newData?.ccOverridColorDis) >= 0
            ? colorCode.greenCd
            : colorCode.disGreyCd;
        newData.bgColorForCcDc2 =
          newData?.ccOverridColorDis === colorCode.greenCd ||
          parseFloat(newData?.ccOverridColorDis) >= 0
            ? colorCode.greenCd
            : colorCode.disGreyCd;
        newData.bgColorForCcDc3 =
          newData?.ccOverridColorDis === colorCode.greenCd ||
          parseFloat(newData?.ccOverridColorDis) >= 0
            ? colorCode.greenCd
            : colorCode.disGreyCd;
      }
      return newData;
    }
  }
  return newData;
};

export const checkInputValueNumber = (value, decimalLength = 2) => {
  let result = 0;
  if (value == '' || value === null || value === undefined) {
    result = parseFloat(0).toFixed(decimalLength);
  } else if (isNaN(value)) {
    result = parseFloat(0).toFixed(decimalLength);
  } else {
    result = parseFloat(value).toFixed(decimalLength);
  }
  if (!result) {
    result = parseFloat(0).toFixed(decimalLength);
  }

  return result;
};
